// import React, { useState, useRef, useMemo, useEffect } from "react";
// import {
//     Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress,
//     Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, Dialog, DialogContent, useMediaQuery, useTheme
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import SearchIcon from '@mui/icons-material/Search';
// import BusinessIcon from '@mui/icons-material/Business';
// import InventoryIcon from '@mui/icons-material/Inventory';
// import PriceCheckIcon from '@mui/icons-material/PriceCheck';
// import WarningIcon from '@mui/icons-material/Warning';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import ProGroupMaster from './ProGroupMaster';
// import { useAuth } from '../context/AuthContext';

// // Simple UUID-like ID generator for unique row IDs
// const generateUniqueId = () => {
//     return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
// };

// const normalize = (s) => String(s || "").trim().toLowerCase();

// // Modern Glass Card with enhanced styling
// const GlassParentCard = ({ children }) => (
//     <Paper
//         elevation={0}
//         sx={{
//             borderRadius: { xs: 2, sm: 3, md: 4 }, background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`, backdropFilter: "blur(20px)", WebKitBackdropFilter: "blur(20px)", border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`, [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } }, boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)", position: "relative", overflow: "hidden", maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" }, display: "flex", flexDirection: "column",
//             "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`, },
//             "&::after": { content: '""', position: "absolute", top: 0, left: 0, width: 4, height: "100%", background: "linear-gradient(180deg, #1976d2, #42a5f5, transparent)", borderRadius: "0 8px 8px 0", }
//         }}
//     >
//         {children}
//     </Paper>
// );

// // Enhanced File Upload Zone
// const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [isDragOver, setIsDragOver] = useState(false);

//     const handleDragOver = (e) => {
//         e.preventDefault();
//         setIsDragOver(true);
//     };

//     const handleDragLeave = () => {
//         setIsDragOver(false);
//     };

//     const handleDrop = (e) => {
//         e.preventDefault();
//         setIsDragOver(false);
//         const droppedFiles = e.dataTransfer.files;
//         if (droppedFiles.length > 0) {
//             fileInputRef.current.files = droppedFiles;
//             const event = new Event('change', { bubbles: true });
//             Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
//             handleFileChange(event);
//         }
//     };

//     return (
//         <Box onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} sx={{ position: "relative", borderRadius: { xs: 2, sm: 3 }, border: `2px dashed ${isDragOver ? '#1976d2' : alpha('#1976d2', 0.3)}`, p: { xs: 2, sm: 3 }, textAlign: "center", transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", background: isDragOver ? alpha('#1976d2', 0.05) : alpha('#1976d2', 0.02), cursor: "pointer", "&:hover": { borderColor: '#1976d2', bgcolor: alpha('#1976d2', 0.04), }, display: "flex", alignItems: "center", justifyContent: "center", minHeight: { xs: 120, sm: 140 }, gap: 2, }} >
//             <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                 <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: '#1976d2', opacity: 0.7 }} />
//                 <Box>
//                     <Typography variant="body1" sx={{ fontWeight: 600, color: "#1976d2", fontSize: { xs: "0.95rem", sm: "1.1rem" }, mb: 0.5 }} >
//                         {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }} >
//                         Excel (.xlsx, .xls) or CSV files only
//                     </Typography>
//                 </Box>
//             </Box>

//             <Button variant="contained" onClick={(e) => { e.stopPropagation(); const hasError = data.some(r => r._missingFields?.length > 0); if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) { return; } fileInputRef.current.click(); }} sx={{ height: { xs: 36, sm: 40 }, bgcolor: "#1976d2", "&:hover": { bgcolor: "#115293" }, borderRadius: 1.5, textTransform: "none", fontWeight: 600, px: { xs: 2, sm: 2.5 }, whiteSpace: "nowrap", fontSize: { xs: "0.85rem", sm: "0.95rem" }, boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", transition: "all 0.3s ease", "&:hover": { bgcolor: "#115293", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)", transform: "translateY(-2px)" } }} >
//                 Browse
//             </Button>
//         </Box>
//     );
// };

// const InsertProduct = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState(null);
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [progressValue, setProgressValue] = useState(0);
//     const [bufferValue, setBufferValue] = useState(0);
//     const [showBuffer, setShowBuffer] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [searchText, setSearchText] = useState("");
//     const [expandedCards, setExpandedCards] = useState({});
//     const [filterMode, setFilterMode] = useState('all');
//     const [groupNames, setGroupNames] = useState([]);
//     const [openGroupPopup, setOpenGroupPopup] = useState(false);
//     const [selectedItemGroup, setSelectedItemGroup] = useState('');
//     const [selectedItemId, setSelectedItemId] = useState('');
//     const [openSearchPopup, setOpenSearchPopup] = useState(false);
//     const [searchGroupQuery, setSearchGroupQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [searchLoading, setSearchLoading] = useState(false);
//     const [showCreateGroupForm, setShowCreateGroupForm] = useState(false);
//     const [selectedGroupFromSearch, setSelectedGroupFromSearch] = useState(null);
//     const [selectedRowId, setSelectedRowId] = useState(null);
//     const [newlyCreatedGroupName, setNewlyCreatedGroupName] = useState(null);
//     const [groupCreatedFromPopup, setGroupCreatedFromPopup] = useState(false);
//     const [rowStatus, setRowStatus] = useState({});
//     const [fadeOutIds, setFadeOutIds] = useState(new Set());

//     const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));

//     console.log("InsertProduct props:", { user, selectedCompany, connectionString });

//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     const userId = user?.UserId || null;
//     const branchId = selectedCompany?.[0]?.BranchId;
//     console.log("username:", user.UserName)

//     const fetchGroupNames = async () => {
//         try {
//             const response = await axios.get(`${path}/api/product-get-data/api/item-group`);
//             const groups = response.data;
//             setGroupNames(groups);
//             return groups;
//         } catch (error) {
//             console.error('Error fetching group names:', error);
//             setSnackbar({ open: true, message: "Error fetching group names", severity: "error" });
//         }
//     };

//     useEffect(() => {
//         fetchGroupNames();
//     }, []);

//     useEffect(() => {
//         const hasRedError = data.some(r => r._missingFields?.length > 0);
//         const handleBeforeUnload = (e) => {
//             if (hasRedError && data.length > 0) {
//                 e.preventDefault();
//                 e.returnValue = '';
//             }
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         return () => window.removeEventListener('beforeunload', handleBeforeUnload);
//     }, [data]);

//     const updateProgress = (value) => {
//         const clipped = Math.max(0, Math.min(100, value));
//         setProgressValue(clipped);
//         setBufferValue(Math.min(100, clipped + 10));
//     };

//     const hasFieldError = (record, fieldKey) => {
//         if (!record._missingFields) return false;
//         const fieldMap = {
//             PrimaryGroup: 'PrimaryGroup',
//             ItemGroup: 'itemGroup',
//             ItemCode: 'itemCode',
//             Description: 'description',
//             Specification: 'Specification',
//             ValueRate: 'ValRate',
//             Unit: 'unit',
//             HSN: 'HSN',
//             GST: 'GST',
//             applyStock: 'applyStock',
//             ApplyBatch: 'applyBatch',
//             Pkg: 'pkg',
//             ConvQty: 'Conversion Qty',
//             OpStock: 'Opening Stock',
//             SaleRate: 'Sale Rate',
//             SaleDiscount: 'Sale Discount (%)',
//             PurchaseRate: 'Purchase Rate',
//             PurchaseDiscount: 'Purchase Discount (%)',
//             MinLevel: 'Min Level',
//             MaxLevel: 'Max Level',
//             MinOrderQty: 'MOQ',
//             SelfLife: 'Self Life'
//         };
//         const errorLabel = fieldMap[fieldKey];
//         return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
//     };

//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             const validExtensions = [".xlsx", ".xls", ".csv"];
//             const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
//             if (!validExtensions.includes(fileExtension)) {
//                 setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
//                 setFile(null);
//                 setData([]);
//                 setFilteredData([]);
//                 fileInputRef.current.value = "";
//                 return;
//             }

//             setFile(selectedFile);
//             fileInputRef.current.value = null;

//             // Reset states
//             setData([]);
//             setFilteredData([]);
//             setRowStatus({});
//             setFadeOutIds(new Set());
//             setShowBuffer(true);
//             setFilterMode('all');
//             updateProgress(3);

//             // Clone file to force fresh read
//             const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
//             processFile(clonedFile);
//         }
//     };

//     const processFile = (file) => {
//         const reader = new FileReader();

//         reader.onprogress = (e) => {
//             if (e.lengthComputable) {
//                 const percentRead = Math.round((e.loaded / e.total) * 100);
//                 const mapped = Math.round(percentRead * 0.5);
//                 updateProgress(mapped);
//             }
//         };

//         reader.onload = (e) => {
//             try {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: "binary" });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const headers = jsonData[0] || [];

//                 // ✅ Build dynamic header index map (column name → index)
//                 const headerIndexMap = {};
//                 headers.forEach((h, i) => {
//                     if (h) headerIndexMap[String(h).trim()] = i;
//                 });

//                 // ✅ Only required columns must exist in file
//                 const requiredColumns = ["PrimaryGroup", "itemGroup", "itemCode", "description", "unit"];
//                 const missingColumns = requiredColumns.filter(col => headerIndexMap[col] === undefined);
//                 if (missingColumns.length > 0) {
//                     setSnackbar({
//                         open: true,
//                         message: `Missing required columns: ${missingColumns.join(", ")}`,
//                         severity: "error"
//                     });
//                     setData([]);
//                     setFilteredData([]);
//                     updateProgress(0);
//                     setShowBuffer(false);
//                     return;
//                 }

//                 const parseNumber = (val) => {
//                     if (val === null || val === undefined || val === "") return "";
//                     const num = parseFloat(String(val).trim());
//                     return isNaN(num) ? "INVALID" : num;
//                 };

//                 const requiredFields = [
//                     { key: 'PrimaryGroup', label: 'PrimaryGroup' },
//                     { key: 'ItemGroup', label: 'itemGroup' },
//                     { key: 'ItemCode', label: 'itemCode' },
//                     { key: 'Description', label: 'description' },
//                     { key: 'Unit', label: 'unit' }
//                 ];

//                 const yesValues = ['Yes', 'yes', 'Y', 'y'];
//                 const noValues = ['No', 'no', 'N', 'n'];

//                 const parsedData = jsonData.slice(1).map((row, idx) => {

//                     // ✅ Helper to get value by column name dynamically
//                     const getVal = (colName) => {
//                         const i = headerIndexMap[colName];
//                         return i !== undefined ? (row[i] ?? "") : "";
//                     };

//                     const raw = {
//                         PrimaryGroup: String(getVal("PrimaryGroup") || "").trim(),
//                         ItemGroup: String(getVal("itemGroup") || "").trim(),
//                         applyStock: String(getVal("applyStock") || "").trim(),
//                         ApplyBatch: String(getVal("applyBatch") || "").trim(),
//                         ItemCode: String(getVal("itemCode") || "").trim(),
//                         Description: String(getVal("description") || "").trim(),
//                         Specification: String(getVal("Specification") || "").trim(),
//                         ValueRate: parseNumber(getVal("ValRate")),
//                         Unit: String(getVal("unit") || "").trim(),
//                         Pkg: parseNumber(getVal("pkg")),
//                         HSN: String(getVal("HSN") || "").trim(),
//                         GST: String(getVal("GST") || "").trim(),
//                         ConvUnit: String(getVal("convUnit") || "").trim(),
//                         ConvQty: parseNumber(getVal("convQty")),
//                         OpStock: parseNumber(getVal("opStock")),
//                         SaleRate: parseNumber(getVal("saleRate")),
//                         SaleDiscount: parseNumber(getVal("saleDiscount")),
//                         PurchaseRate: parseNumber(getVal("purchaseRate")),
//                         PurchaseDiscount: parseNumber(getVal("purchaseDiscount")),
//                         MinLevel: parseNumber(getVal("minLevel")),
//                         MaxLevel: parseNumber(getVal("maxLevel")),
//                         MinOrderQty: parseNumber(getVal("minOrderQty")),
//                         SelfLife: parseNumber(getVal("selfLife"))
//                     };

//                     const errors = [];

//                     requiredFields.forEach(f => {
//                         if (!raw[f.key]) {
//                             errors.push(f.label);
//                         }
//                     });

//                     if (raw.applyStock && !yesValues.includes(raw.applyStock) && !noValues.includes(raw.applyStock)) {
//                         errors.push("applyStock (must be Yes/Y or No/N)");
//                     }
//                     if (raw.ApplyBatch && !yesValues.includes(raw.ApplyBatch) && !noValues.includes(raw.ApplyBatch)) {
//                         errors.push("applyBatch (must be Yes/Y or No/N)");
//                     }

//                     if (raw.Pkg === "INVALID") {
//                         errors.push("Pkg. (must be a number like 5 or 3.7)");
//                     }

//                     if (raw.GST && !/^\d+$/.test(raw.GST)) {
//                         errors.push("GST (must be integer like 10, 18, 28)");
//                     }

//                     if (raw.HSN) {
//                         const hsnDigits = raw.HSN.replace(/\D/g, '');
//                         const digitCount = hsnDigits.length;
//                         if (digitCount !== 4 && digitCount !== 6 && digitCount !== 8) {
//                             errors.push("HSN (must be 4, 6, or 8 digits)");
//                         }
//                     }

//                     const numericFields = [
//                         { key: 'Pkg', label: 'Pkg.' },
//                         { key: 'ConvQty', label: 'Conversion Qty' },
//                         { key: 'OpStock', label: 'Opening Stock' },
//                         { key: 'SaleRate', label: 'Sale Rate' },
//                         { key: 'SaleDiscount', label: 'Sale Discount (%)' },
//                         { key: 'PurchaseRate', label: 'Purchase Rate' },
//                         { key: 'PurchaseDiscount', label: 'Purchase Discount (%)' },
//                         { key: 'MinLevel', label: 'Min Level' },
//                         { key: 'MaxLevel', label: 'Max Level' },
//                         { key: 'MinOrderQty', label: 'MOQ' },
//                         { key: 'SelfLife', label: 'Self Life' }
//                     ];

//                     numericFields.forEach(f => {
//                         const value = raw[f.key];
//                         if (value === "" || value === null) return;
//                         if (value === "INVALID" || isNaN(value)) {
//                             errors.push(`${f.label} (must be a number like 5 or 3.4)`);
//                         }
//                     });

//                     const matchedGroup = groupNames.find(g =>
//                         normalize(g.GroupName) === normalize(raw.ItemGroup) &&
//                         g.IsPrimary === 0
//                     );

//                     const showAddIcon = !matchedGroup;

//                     const record = {
//                         id: generateUniqueId(),
//                         PrimaryGroup: raw.PrimaryGroup,
//                         ItemGroup: raw.ItemGroup,
//                         applyStock: raw.applyStock === "" ? 0 : yesValues.includes(raw.applyStock) ? 1 : noValues.includes(raw.applyStock) ? 0 : raw.applyStock,
//                         ApplyBatch: raw.ApplyBatch === "" ? 0 : yesValues.includes(raw.ApplyBatch) ? 1 : noValues.includes(raw.ApplyBatch) ? 0 : raw.ApplyBatch,
//                         ItemCode: raw.ItemCode,
//                         Description: raw.Description,
//                         Specification: raw.Specification,
//                         ValueRate: raw.ValueRate === "" || raw.ValueRate === "INVALID" ? 0 : raw.ValueRate,  
//                         Unit: raw.Unit,
//                         Pkg: raw.Pkg === "" || raw.Pkg === "INVALID" ? 0 : raw.Pkg,
//                         HSN: raw.HSN ? raw.HSN.replace(/\D/g, '') : "",
//                         GST: raw.GST ? parseInt(raw.GST, 10) : 0,
//                         ConvQty: raw.ConvQty === "" || raw.ConvQty === "INVALID" ? 0 : raw.ConvQty,
//                         OpStock: raw.OpStock === "" || raw.OpStock === "INVALID" ? "" : raw.OpStock,
//                         SaleRate: raw.SaleRate === "" || raw.SaleRate === "INVALID" ? 0 : raw.SaleRate,
//                         SaleDiscount: raw.SaleDiscount === "" || raw.SaleDiscount === "INVALID" ? 0 : raw.SaleDiscount,
//                         PurchaseRate: raw.PurchaseRate === "" || raw.PurchaseRate === "INVALID" ? 0 : raw.PurchaseRate,
//                         PurchaseDiscount: raw.PurchaseDiscount === "" || raw.PurchaseDiscount === "INVALID" ? 0 : raw.PurchaseDiscount,
//                         MinLevel: raw.MinLevel === "" || raw.MinLevel === "INVALID" ? 0 : raw.MinLevel,
//                         MaxLevel: raw.MaxLevel === "" || raw.MaxLevel === "INVALID" ? 0 : raw.MaxLevel,
//                         MinOrderQty: raw.MinOrderQty === "" || raw.MinOrderQty === "INVALID" ? 0 : raw.MinOrderQty,
//                         SelfLife: raw.SelfLife === "" || raw.SelfLife === "INVALID" ? 0 : raw.SelfLife,
//                         ConvUnit: raw.ConvUnit,
//                         companyId,
//                         fYear,
//                         userId,
//                         _missingFields: errors,
//                         isGroupValid: !!matchedGroup,
//                         showAddIcon: showAddIcon,
//                         isGroupMissing: !matchedGroup,
//                         isGroupNotFound: !matchedGroup
//                     };

//                     return record;
//                 }).filter(row => row.ItemCode || row.Description || row.Unit);

//                 setData(parsedData);
//                 setFilteredData(parsedData);
//                 setRowStatus({});
//                 setFadeOutIds(new Set());

//                 updateProgress(50);
//                 setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

//                 updateProgress(100);
//                 setTimeout(() => {
//                     setShowBuffer(false);
//                     updateProgress(0);
//                 }, 800);
//             } catch (err) {
//                 console.error(err);
//                 setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
//                 setData([]);
//                 setFilteredData([]);
//                 updateProgress(0);
//                 setShowBuffer(false);
//             }
//         };

//         reader.onerror = () => {
//             setSnackbar({ open: true, message: "Error reading file", severity: "error" });
//             setData([]);
//             setFilteredData([]);
//             updateProgress(0);
//             setShowBuffer(false);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const handleAddGroupClick = (itemGroup, rowId) => {
//         setSelectedItemGroup(itemGroup);
//         setSelectedRowId(rowId);
//         setOpenSearchPopup(true);
//         setSearchGroupQuery('');
//         setSearchResults([]);
//         setShowCreateGroupForm(false);
//     };

//     const handleSelectGroupFromSearch = async (selectedGroup) => {
//         try {
//             const groupsResponse = await axios.get(`${path}/api/product-get-data/api/item-group?companyId=${companyId}`);
//             const allGroups = groupsResponse.data;

//             let primaryGroupName = '';
//             if (selectedGroup.UnderGRP) {
//                 const primaryGroup = allGroups.find(g =>
//                     String(g.ProdGRPID) === String(selectedGroup.UnderGRP) &&
//                     g.IsPrimary === 1
//                 );
//                 if (primaryGroup) {
//                     primaryGroupName = primaryGroup.GroupName;
//                 }
//             }

//             const updateRowWithGroup = (rows) => {
//                 return rows.map(row => {
//                     if (row.id === selectedRowId) {
//                         return {
//                             ...row,
//                             ItemGroup: selectedGroup.GroupName,
//                             PrimaryGroup: primaryGroupName,
//                             isGroupValid: true,
//                             showAddIcon: false,
//                             isGroupMissing: false,
//                             isGroupNotFound: false,
//                             _missingFields: (row._missingFields || []).filter(
//                                 err => !err.toLowerCase().includes("group")
//                             )
//                         };
//                     }
//                     return row;
//                 });
//             };

//             setData(prevData => updateRowWithGroup(prevData));
//             setFilteredData(prevFilteredData => updateRowWithGroup(prevFilteredData));

//         } catch (error) {
//             console.error('Error selecting group:', error);
//             setSnackbar({ open: true, message: "Error selecting group", severity: "error" });
//         }

//         setOpenSearchPopup(false);
//         setSearchGroupQuery('');
//         setSearchResults([]);
//         setShowCreateGroupForm(false);
//         setSelectedRowId(null);
//     };

//     const handleSearchGroups = async (searchText) => {
//         setSearchGroupQuery(searchText);

//         if (!searchText.trim()) {
//             setSearchResults([]);
//             return;
//         }

//         try {
//             setSearchLoading(true);
//             const params = {
//                 GroupCode: searchText,
//                 companyId: companyId,
//                 mode: 'search'
//             };

//             const dataRes = await axios.get(`${path}/api/group/search`, { params });
//             setSearchResults(dataRes.data || []);
//         } catch (error) {
//             console.error('Error searching groups:', error);
//             setSnackbar({ open: true, message: "Error searching groups", severity: "error" });
//             setSearchResults([]);
//         } finally {
//             setSearchLoading(false);
//         }
//     };

//     const handleOpenCreateGroupForm = () => {
//         setShowCreateGroupForm(true);
//         setOpenSearchPopup(true);
//     };

//     const handleCloseSearchPopup = async (meta) => {
//         const createdGroupName = meta?.created ? meta.groupName : null;
//         if (meta?.created) setGroupCreatedFromPopup(true);

//         try {
//             if (selectedGroupFromSearch && selectedRowId) {
//                 const { data: allGroups } = await axios.get(
//                     `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
//                 );

//                 let primaryGroupName = '';

//                 if (selectedGroupFromSearch.UnderGRP) {
//                     const primary = allGroups.find(
//                         g =>
//                             String(g.ProdGRPID) === String(selectedGroupFromSearch.UnderGRP) &&
//                             g.IsPrimary === 1
//                     );
//                     if (primary) primaryGroupName = primary.GroupName;
//                 }

//                 const patchRow = rows =>
//                     rows.map(row =>
//                         row.id === selectedRowId
//                             ? {
//                                 ...row,
//                                 ItemGroup: selectedGroupFromSearch.GroupName,
//                                 PrimaryGroup: primaryGroupName,
//                                 isGroupValid: true,
//                                 showAddIcon: false,
//                                 isGroupMissing: false,
//                                 isGroupNotFound: false,
//                                 _missingFields: (row._missingFields || []).filter(
//                                     err => !err.toLowerCase().includes("group")
//                                 )
//                             }
//                             : row
//                     );

//                 setData(prev => patchRow(prev));
//                 setFilteredData(prev => patchRow(prev));
//             } else if ((createdGroupName || groupCreatedFromPopup) && selectedRowId) {
//                 const groupNameToMatch = createdGroupName || selectedItemGroup;

//                 const { data: allGroups } = await axios.get(
//                     `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
//                 );

//                 const newlyCreatedGroup = allGroups.find(
//                     g =>
//                         normalize(g.GroupName) === normalize(groupNameToMatch) &&
//                         g.IsPrimary === 0 &&
//                         g.UnderGRP
//                 );

//                 if (newlyCreatedGroup) {
//                     let primaryGroupName = '';

//                     const primary = allGroups.find(
//                         g =>
//                             String(g.ProdGRPID) === String(newlyCreatedGroup.UnderGRP) &&
//                             g.IsPrimary === 1
//                     );

//                     if (primary) primaryGroupName = primary.GroupName;

//                     const patchRow = rows =>
//                         rows.map(row =>
//                             row.id === selectedRowId
//                                 ? {
//                                     ...row,
//                                     ItemGroup: newlyCreatedGroup.GroupName,
//                                     PrimaryGroup: primaryGroupName,
//                                     isGroupValid: true,
//                                     showAddIcon: false,
//                                     isGroupMissing: false,
//                                     isGroupNotFound: false,
//                                     _missingFields: (row._missingFields || []).filter(
//                                         err => !err.toLowerCase().includes("group")
//                                     )
//                                 }
//                                 : row
//                         );

//                     setData(prev => patchRow(prev));
//                     setFilteredData(prev => patchRow(prev));
//                 }
//             }

//             const updatedGroups = await fetchGroupNames();

//             setData(prev =>
//                 prev.map(row => {
//                     const matched = updatedGroups.find(
//                         g =>
//                             normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                             g.IsPrimary === 0
//                     );

//                     if (!matched) return row;

//                     let primaryGroupName = row.PrimaryGroup;

//                     if (matched.UnderGRP) {
//                         const primary = updatedGroups.find(
//                             g =>
//                                 String(g.ProdGRPID) === String(matched.UnderGRP) &&
//                                 g.IsPrimary === 1
//                         );
//                         if (primary) primaryGroupName = primary.GroupName;
//                     }

//                     return {
//                         ...row,
//                         ItemGroup: matched.GroupName,
//                         PrimaryGroup: primaryGroupName,
//                         isGroupValid: true,
//                         showAddIcon: false,
//                         isGroupMissing: false,
//                         isGroupNotFound: false
//                     };
//                 })
//             );

//             setFilteredData(prev =>
//                 prev.map(row => {
//                     const matched = updatedGroups.find(
//                         g =>
//                             normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                             g.IsPrimary === 0
//                     );

//                     if (!matched) return row;

//                     let primaryGroupName = row.PrimaryGroup;

//                     if (matched.UnderGRP) {
//                         const primary = updatedGroups.find(
//                             g =>
//                                 String(g.ProdGRPID) === String(matched.UnderGRP) &&
//                                 g.IsPrimary === 1
//                         );
//                         if (primary) primaryGroupName = primary.GroupName;
//                     }

//                     return {
//                         ...row,
//                         ItemGroup: matched.GroupName,
//                         PrimaryGroup: primaryGroupName,
//                         isGroupValid: true,
//                         showAddIcon: false,
//                         isGroupMissing: false,
//                         isGroupNotFound: false
//                     };
//                 })
//             );
//         } catch (error) {
//             console.error('handleCloseSearchPopup error:', error);
//             setSnackbar({
//                 open: true,
//                 message: 'Error resolving Item Group',
//                 severity: 'error'
//             });
//         } finally {
//             setOpenSearchPopup(false);
//             setSearchGroupQuery('');
//             setSearchResults([]);
//             setShowCreateGroupForm(false);
//             setSelectedGroupFromSearch(null);
//             setSelectedRowId(null);
//             setGroupCreatedFromPopup(false);
//         }
//     };

//     useEffect(() => {
//         if (!groupNames.length || !data.length) return;

//         setData(prev => prev.map(row => {
//             const m = groupNames.find(g =>
//                 normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                 g.IsPrimary === 0
//             );
//             return { ...row, showAddIcon: !m };
//         }));
//     }, [groupNames]);

//     const handleGroupPopupClose = async () => {
//         setOpenGroupPopup(false);
//         setSelectedItemGroup('');

//         const updatedGroups = await fetchGroupNames();

//         setData(prevData =>
//             prevData.map(row => {
//                 const matchedGroup = updatedGroups.find(g =>
//                     normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                     g.IsPrimary === 0
//                 );

//                 const shouldShowAddIcon = !matchedGroup;

//                 let primaryGroupName = row.PrimaryGroup;
//                 let itemGroupName = row.ItemGroup;

//                 if (matchedGroup) {
//                     itemGroupName = matchedGroup.GroupName;

//                     if (matchedGroup.UnderGRP) {
//                         const primaryGroup = updatedGroups.find(g =>
//                             String(g.ProdGRPID) === String(matchedGroup.UnderGRP) &&
//                             g.IsPrimary === 1
//                         );
//                         if (primaryGroup) {
//                             primaryGroupName = primaryGroup.GroupName;
//                         }
//                     }
//                 }

//                 return {
//                     ...row,
//                     PrimaryGroup: primaryGroupName,
//                     ItemGroup: itemGroupName,
//                     isGroupValid: !!matchedGroup && matchedGroup.IsPrimary === 0,
//                     showAddIcon: shouldShowAddIcon
//                 };
//             })
//         );
//     };

//     const handleUploadSubmit = async () => {
//         if (!data.length) {
//             setSnackbar({ open: true, message: "No data to upload", severity: "error" });
//             return;
//         }

//         const validRows = data.filter(r =>
//             (!r._missingFields || r._missingFields.length === 0) &&
//             !r.isGroupNotFound
//         );
//         const errorRows = data.filter(r => r._missingFields?.length > 0);

//         if (validRows.length === 0) {
//             setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
//             return;
//         }

//         if (!companyId || !userId) {
//             setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
//             return;
//         }

//         setUploading(true);
//         setShowBuffer(true);
//         updateProgress(0);

//         let insertedCount = 0;
//         let existsCount = 0;
//         let notModifiedCount = 0;
//         let failedCount = 0;
//         const processedRowIds = [];

//         try {
//             for (let i = 0; i < validRows.length; i++) {
//                 const row = validRows[i];

//                 const payload = {
//                     GroupId: '',
//                     itemGroup: row.ItemGroup,
//                     inStock: row.applyStock === 1 || row.applyStock === "1" ? 1 : 0,
//                     applyBatch: row.ApplyBatch === 1 || row.ApplyBatch === "1" ? 1 : 0,
//                     itemCode: row.ItemCode,
//                     description: row.Description,
//                     specification: row.Specification,
//                     valueRate: row.ValueRate,
//                     unit: row.Unit,
//                     pkg: row.Pkg || 0,
//                     HSN: row.HSN,
//                     GST: row.GST,
//                     optionalBalance: row.OpStock,
//                     saleRate: row.SaleRate,
//                     saleDiscount: row.SaleDiscount,
//                     purchaseRate: row.PurchaseRate,
//                     purchaseDiscount: row.PurchaseDiscount,
//                     convUnit: row.ConvUnit || "",
//                     convQty: row.ConvQty,
//                     minLevel: row.MinLevel,
//                     maxLevel: row.MaxLevel,
//                     minOrderQty: row.MinOrderQty,
//                     selfLife: row.SelfLife,
//                     companyId,
//                     addUserId: userId,
//                     addUserDateTime: new Date().toISOString(),
//                     branchId,
//                     groupOfCompanyId: companyId
//                 };

//                 try {
//                     const response = await axios.post(`${path}/api/product-bulk-Insert`, payload, {
//                         validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
//                     });

//                     const status = response.status;
//                     let message = "";
//                     let severity = "error";

//                     if (status === 201) {
//                         message = "Inserted";
//                         insertedCount++;
//                         severity = "success";
//                     } else if (status === 204) {
//                         message = "Already Exists";
//                         existsCount++;
//                         severity = "warning";
//                     } else if (status === 304) {
//                         message = "Group not found";
//                         notModifiedCount++;
//                         severity = "warning";
//                     } else if (status === 500) {
//                         message = "Server Error";
//                         failedCount++;
//                         severity = "error";
//                     }

//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message, severity }
//                     }));

//                     if (status === 201 || status === 204) {
//                         processedRowIds.push(row.id);
//                     }

//                     console.log(`Row ${i + 1} - Status: ${status} - ${message}`);
//                 } catch (err) {
//                     const status = err.response?.status || 500;
//                     const message = status === 500 ? "Server Error" : "Failed";
//                     failedCount++;
//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message, severity: "error" }
//                     }));
//                 }

//                 const progress = 50 + Math.round(((i + 1) / validRows.length) * 50);
//                 updateProgress(progress);
//             }

//             const parts = [];
//             if (insertedCount) parts.push(`${insertedCount} Inserted`);
//             if (existsCount) parts.push(`${existsCount} Already Exists`);
//             if (notModifiedCount) parts.push(`${notModifiedCount} Not Modified`);
//             if (failedCount) parts.push(`${failedCount} Failed`);
//             if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

//             setSnackbar({
//                 open: true,
//                 message: parts.join(" | "),
//                 severity: insertedCount > 0 ? "success" : "warning"
//             });

//             setTimeout(() => {
//                 const sortedFadeIds = processedRowIds
//                     .map(id => ({ id, group: data.find(r => r.id === id)?.ItemGroup || "" }))
//                     .sort((a, b) => (a.group || "").localeCompare(b.group || ""))
//                     .map(item => item.id);

//                 sortedFadeIds.forEach((id, index) => {
//                     setTimeout(() => {
//                         setFadeOutIds(prev => new Set(prev).add(id));
//                     }, index * 1000);
//                 });

//                 setTimeout(() => {
//                     setData(prev => prev.filter(r => !processedRowIds.includes(r.id)));
//                     setRowStatus({});
//                     setFadeOutIds(new Set());
//                 }, processedRowIds.length * 1000 + 600);
//             }, 5000);

//         } catch (error) {
//             console.error("Unexpected error:", error);
//             setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
//         } finally {
//             setUploading(false);
//             setShowBuffer(false);
//             updateProgress(0);
//         }
//     };

//     const handleBackClick = () => { navigate("/main/productMaster"); };

//     const sortedData = useMemo(() => {
//         const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
//         const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

//         const groupNotFound = withoutError.filter(r => r.isGroupNotFound);
//         const validRows = withoutError.filter(r => !r.isGroupNotFound);

//         const sortByItemGroup = (a, b) => {
//             const groupA = (a.ItemGroup || "").trim().toLowerCase();
//             const groupB = (b.ItemGroup || "").trim().toLowerCase();
//             return groupA.localeCompare(groupB);
//         };

//         const sortedWithError = [...withError].sort(sortByItemGroup);
//         const sortedGroupNotFound = [...groupNotFound].sort(sortByItemGroup);
//         const sortedValid = [...validRows].sort(sortByItemGroup);

//         return [...sortedWithError, ...sortedGroupNotFound, ...sortedValid];
//     }, [data]);

//     const filteredDataFinal = useMemo(() => {
//         let result = sortedData;

//         if (filterMode === 'perfect') {
//             result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
//         } else if (filterMode === 'error') {
//             result = result.filter(r => r._missingFields?.length > 0);
//         }

//         if (searchText.trim()) {
//             const lowerSearch = searchText.toLowerCase();
//             result = result.filter(row =>
//                 row.Description?.toLowerCase().includes(lowerSearch) ||
//                 row.ItemCode?.toLowerCase().includes(lowerSearch) ||
//                 row.Unit?.toLowerCase().includes(lowerSearch)
//             );
//         }

//         return result;
//     }, [sortedData, filterMode, searchText]);

//     useMemo(() => {
//         setFilteredData(filteredDataFinal);
//     }, [filteredDataFinal]);

//     const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
//     const perfectCount = useMemo(() => data.length - errorCount, [data]);
//     const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

//     const fieldGroups = [
//         {
//             title: "Basic Info",
//             icon: <BusinessIcon fontSize="small" />,
//             fields: [
//                 { label: "Primary Group", key: "PrimaryGroup" },
//                 { label: "Item Group", key: "ItemGroup" },
//                 { label: "applyStock", key: "applyStock" },
//                 { label: "applyBatch", key: "ApplyBatch" },
//                 { label: "Item Code", key: "ItemCode" },
//                 { label: "Description", key: "Description" },
//                 { label: "Specification", key: "Specification" },
//                 { label: "Value Rate", key: "ValueRate" },
//                 { label: "Unit", key: "Unit" },
//                 { label: "Pkg.", key: "Pkg" },
//                 { label: "HSN", key: "HSN" },
//                 { label: "GST", key: "GST" },
//             ]
//         },
//         {
//             title: "Conversion & Stock",
//             icon: <InventoryIcon fontSize="small" />,
//             fields: [
//                 { label: "Conversion Unit", key: "ConvUnit" },
//                 { label: "Conversion Qty", key: "ConvQty" },
//                 { label: "Opening Stock", key: "OpStock" },
//                 { label: "Min Level", key: "MinLevel" },
//                 { label: "Max Level", key: "MaxLevel" },
//                 { label: "MOQ", key: "MinOrderQty" },
//                 { label: "Self Life", key: "SelfLife" },
//             ]
//         },
//         {
//             title: "Pricing",
//             icon: <PriceCheckIcon fontSize="small" />,
//             fields: [
//                 { label: "Sale Rate", key: "SaleRate" },
//                 { label: "Sale Discount (%)", key: "SaleDiscount" },
//                 { label: "Purchase Rate", key: "PurchaseRate" },
//                 { label: "Purchase Discount (%)", key: "PurchaseDiscount" },
//             ]
//         }
//     ];

//     return (
//         <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
//             {/* Header Section with enhanced styling */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
//                 <Box>
//                     <Typography variant="h4" sx={{ fontWeight: 700, background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" }, letterSpacing: "-0.5px" }} >
//                         Product Data Upload
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} >
//                         Manage and import your product information
//                     </Typography>
//                 </Box>
//                 <Tooltip title="Back to Product Master" placement="left">
//                     <IconButton onClick={handleBackClick} sx={{ bgcolor: "#1976d2", color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, "&:hover": { bgcolor: "#115293", transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)" }, borderRadius: 1.5, transition: "all 0.3s ease", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", flexShrink: 0 }} >
//                         <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
//                     </IconButton>
//                 </Tooltip>
//             </Box>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//                 {/* File Upload Card */}
//                 <Paper sx={{ px: { xs: 3, sm: 3.5 }, py: { xs: 2, sm: 2.5 }, borderRadius: { xs: 2.5, sm: 3 }, bgcolor: "background.paper", boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)", border: `1px solid ${alpha('#1976d2', 0.1)}`, position: "relative", overflow: "hidden", "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`, } }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                         {/* File Upload Zone */}
//                         <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

//                         {/* Upload Controls & Progress */}
//                         {(file || data.length > 0) && (
//                             <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
//                                 <Button variant="contained" onClick={handleUploadSubmit} disabled={uploading || !data.length || validRowsCount === 0} sx={{ height: { xs: 40, sm: 44 }, bgcolor: "#1976d2", "&:hover": { bgcolor: "#115293", boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)", transform: "translateY(-2px)" }, borderRadius: 1.5, textTransform: "none", fontWeight: 700, px: { xs: 2, sm: 3 }, "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" }, fontSize: { xs: "0.95rem", sm: "1.05rem" }, minWidth: { xs: "auto", sm: 140 }, transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", gap: 1 }} >
//                                     {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
//                                     {uploading ? "Uploading..." : "Upload Records"}
//                                 </Button>
//                                 {showBuffer && (
//                                     <Box sx={{ width: { xs: "100%", sm: 280 } }}>
//                                         <LinearProgress variant="buffer" value={progressValue} valueBuffer={bufferValue} sx={{ height: 4, borderRadius: 4, backgroundColor: alpha('#1976d2', 0.1), "& .MuiLinearProgress-bar": { borderRadius: 4, background: "linear-gradient(90deg, #1976d2, #42a5f5)" } }} />
//                                         <Typography variant="caption" sx={{ display: "block", textAlign: "center", fontSize: { xs: "0.75rem", sm: "0.85rem" }, fontWeight: 600, color: "#1976d2" }} >
//                                             {uploading ? `${Math.round(progressValue)}%` : `Ready`}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>
//                         )}

//                         {/* Statistics Chips */}
//                         {data.length > 0 && (
//                             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
//                                 <Chip icon={<CheckCircleIcon sx={{ fontSize: 18 }} />} label={`${perfectCount} Valid`} onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')} variant={filterMode === 'perfect' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'perfect' ? '#4caf50' : 'transparent', color: filterMode === 'perfect' ? 'white' : '#4caf50', fontWeight: 700, border: filterMode === 'perfect' ? 'none' : '2px solid #4caf50', cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha('#4caf50', 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
//                                 <Chip icon={<ErrorIcon sx={{ fontSize: 18 }} />} label={`${errorCount} Errors`} onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')} variant={filterMode === 'error' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'error' ? '#f44336' : 'transparent', color: filterMode === 'error' ? 'white' : '#f44336', fontWeight: 700, border: filterMode === 'error' ? 'none' : '2px solid #f44336', cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'error' ? '#d32f2f' : alpha('#f44336', 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>

//                 {/* Data Display Section */}
//                 {data.length > 0 && (
//                     <GlassParentCard>
//                         {/* Search Bar */}
//                         <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
//                             <TextField fullWidth size="small" placeholder={isMobile ? "Search products..." : "Search by description, code, unit..."} value={searchText} onChange={(e) => setSearchText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon sx={{ fontSize: 22, color: "#1976d2" }} />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.paper", fontSize: { xs: "0.9rem", sm: "1rem" }, border: `1.5px solid ${alpha('#1976d2', 0.2)}`, transition: "all 0.3s ease", "&:hover": { borderColor: alpha('#1976d2', 0.4) }, "&.Mui-focused": { borderColor: "#1976d2", boxShadow: `0 0 0 3px ${alpha('#1976d2', 0.1)}` } } }}
//                             />
//                         </Box>

//                         {/* Records Container */}
//                         <Box flex={1} overflow="auto" p={{ xs: 1.5, sm: 2 }} pt={0} sx={{ maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" }, '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-track': { background: alpha('#1976d2', 0.05), borderRadius: '10px' }, '&::-webkit-scrollbar-thumb': { background: '#1976d2', borderRadius: '10px', '&:hover': { background: '#115293' } } }} >
//                             <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
//                                 {filteredData.length === 0 ? (
//                                     <Paper sx={{ p: 2.5, textAlign: "center", borderRadius: 3, bgcolor: alpha("#1976d2", 0.02), border: `1px dashed ${alpha("#1976d2", 0.2)}` }}>
//                                         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                                             <SearchIcon sx={{ fontSize: 48, color: alpha("#1976d2", 0.3), mb: 1 }} />
//                                             <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
//                                                 {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
//                                             </Typography>
//                                         </Box>
//                                     </Paper>
//                                 ) : (
//                                     filteredData.map((r, idx) => {
//                                         const missing = r._missingFields || [];
//                                         const isError = missing.length > 0;
//                                         const expanded = expandedCards[r.id];
//                                         const statusInfo = rowStatus[r.id];
//                                         const isFading = fadeOutIds.has(r.id);

//                                         let cardBg = "background.paper";
//                                         let borderColor = alpha('#1976d2', 0.2);
//                                         let statusChip = null;

//                                         if (statusInfo) {
//                                             if (statusInfo.status === 201) {
//                                                 cardBg = "#e8f5e9";
//                                                 borderColor = "#4caf50";
//                                                 statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
//                                             } else if ([204, 304].includes(statusInfo.status)) {
//                                                 cardBg = "#fff8e1";
//                                                 borderColor = "#ffb300";
//                                                 const label = statusInfo.status === 204 ? "Already Exists" : "Group not found";
//                                                 statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label };
//                                             } else {
//                                                 cardBg = "#ffebee";
//                                                 borderColor = "#f44336";
//                                                 statusChip = { color: "#c62828", bg: "#f44336", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
//                                             }
//                                         } else if (isError) {
//                                             cardBg = "#ffebee";
//                                             borderColor = "#f44336";
//                                         }

//                                         return (
//                                             <Card key={r.id} elevation={isError ? 4 : 2} sx={{ borderRadius: { xs: 2, sm: 2.5, md: 3 }, bgcolor: cardBg, border: `2px solid ${borderColor}`, position: "relative", overflow: "visible", transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", opacity: isFading ? 0 : 1, transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)", height: isFading ? 0 : "auto", marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 }, padding: isFading ? 0 : { xs: 1, sm: 1.5 }, "&:hover": { boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)", } }} >
//                                                 {statusChip && !isFading && (
//                                                     <Box sx={{ position: "absolute", bottom: 8, right: 12, bgcolor: statusChip.bg, color: statusChip.bg === '#ffb300' ? '#000' : 'white', px: 1.25, py: 0.4, borderRadius: 1.5, fontSize: { xs: "0.7rem", sm: "0.8rem" }, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5, zIndex: 1, boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}` }} >
//                                                         {statusChip.icon}
//                                                         {statusChip.label}
//                                                     </Box>
//                                                 )}

//                                                 <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
//                                                     {/* Main Header Row */}
//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: { xs: 1.5, sm: 2, md: 4 }, flexWrap: { xs: "wrap", sm: "nowrap" } }} >
//                                                         {/* Item Info */}
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
//                                                             <Box sx={{ background: statusInfo?.status === 201 ? "linear-gradient(135deg, #4caf50, #66bb6a)" : (isError ? "linear-gradient(135deg, #f44336, #ef5350)" : "linear-gradient(135deg, #1976d2, #42a5f5)"), color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0, fontSize: { xs: "1.1rem", sm: "1.3rem" }, boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }} >
//                                                                 {r.ItemGroup?.[0]?.toUpperCase() || "?"}
//                                                             </Box>
//                                                             <Box sx={{ minWidth: 0, flex: 1 }}>
//                                                                 <Typography variant="h6" fontWeight={700} noWrap sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }} >
//                                                                     {r.ItemGroup || "Unnamed"}
//                                                                 </Typography>
//                                                                 <Typography variant="body2" color="text.secondary" noWrap sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }} >
//                                                                     {r.ItemCode || "—"} • {r.Unit || "—"}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </Box>

//                                                         {/* Quick Info - Responsive Grid */}
//                                                         <Box sx={{ display: 'grid', gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: { xs: 1.25, sm: 1.75 }, alignItems: 'flex-start', flex: { xs: "0 0 100%", sm: "auto" }, width: { xs: "100%", sm: "auto" } }} >
//                                                             {[
//                                                                 { label: "HSN", value: r.HSN || "—", key: "HSN", icon: "📍" },
//                                                                 { label: "GST", value: r.GST || "—", key: "GST", icon: "🏛️" },
//                                                                 { label: "Sale Rate", value: r.SaleRate || "—", key: "SaleRate", icon: "💰" },
//                                                                 { label: "Group", value: r.ItemGroup || "—", key: "ItemGroup", icon: "📦" }
//                                                             ].map((item, i) => {
//                                                                 const hasErr = hasFieldError(r, item.key);
//                                                                 return (
//                                                                     <Box key={i} sx={{ bgcolor: hasErr ? alpha('#f44336', 0.08) : alpha('#1976d2', 0.04), borderRadius: 1.5, p: 1, transition: 'all 0.2s ease', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0, border: `1px solid ${hasErr ? alpha('#f44336', 0.2) : alpha('#1976d2', 0.1)}` }} >
//                                                                         <Typography variant="caption" sx={{ fontWeight: 700, color: hasErr ? '#f44336' : 'text.secondary', lineHeight: 1.3, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.5px" }} >
//                                                                             {item.label}
//                                                                         </Typography>
//                                                                         <Typography variant="body2" fontWeight={600} noWrap sx={{ mt: 0.4, wordBreak: 'break-word', maxWidth: '100%', fontSize: { xs: "0.75rem", sm: "0.9rem" }, color: "#000" }} >
//                                                                             {item.value}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                 );
//                                                             })}
//                                                         </Box>

//                                                         {/* Actions - Expand + Add Group Button */}
//                                                         <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'flex-start', flexShrink: 0 }}>
//                                                             {r.showAddIcon && (
//                                                                 <Tooltip title="Add this Item Group">
//                                                                     <IconButton onClick={() => handleAddGroupClick(r.ItemGroup, r.id)} sx={{ bgcolor: "#4caf50", color: "white", width: { xs: 36, sm: 40 }, height: { xs: 36, sm: 40 }, "&:hover": { bgcolor: "#388e3c", transform: 'scale(1.1)', boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)" }, borderRadius: 1.5, transition: 'all 0.3s ease', flexShrink: 0 }} >
//                                                                         <AddCircleIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
//                                                                     </IconButton>
//                                                                 </Tooltip>
//                                                             )}
//                                                             <IconButton size="small" onClick={() => toggleExpand(r.id)} sx={{ alignSelf: 'flex-start', flexShrink: 0, bgcolor: alpha('#1976d2', 0.1), color: '#1976d2', width: { xs: 36, sm: 40 }, height: { xs: 36, sm: 40 }, transition: 'all 0.3s ease', "&:hover": { bgcolor: alpha('#1976d2', 0.2), transform: 'scale(1.1)' } }} >
//                                                                 {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
//                                                             </IconButton>
//                                                         </Box>
//                                                     </Box>

//                                                     {/* Expanded Details */}
//                                                     <Collapse in={expanded} timeout="auto" unmountOnExit>
//                                                         <Divider sx={{ my: 1.5 }} />
//                                                         <Box mt={1.5}>
//                                                             {fieldGroups.map((group, gIdx) => (
//                                                                 <Box key={gIdx} mb={2}>
//                                                                     <Typography variant="subtitle2" color="primary" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: { xs: "0.85rem", sm: "1rem" }, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px" }} >
//                                                                         {group.icon} {group.title}
//                                                                     </Typography>
//                                                                     <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                                                         {group.fields.map((f, fIdx) => (
//                                                                             <Grid item xs={12} sm={6} key={fIdx}>
//                                                                                 <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha('#1976d2', 0.02), border: `1px solid ${alpha('#1976d2', 0.1)}` }}>
//                                                                                     <Typography variant="caption" sx={{ color: hasFieldError(r, f.key) ? '#f44336' : 'text.secondary', fontWeight: hasFieldError(r, f.key) ? 700 : 600, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.3px" }} >
//                                                                                         {f.label}
//                                                                                     </Typography>
//                                                                                     <Typography variant="body2" fontWeight={600} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }} >
//                                                                                         {r[f.key] || "—"}
//                                                                                     </Typography>
//                                                                                 </Box>
//                                                                             </Grid>
//                                                                         ))}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Collapse>
//                                                 </CardContent>
//                                             </Card>
//                                         );
//                                     })
//                                 )}
//                             </Stack>
//                         </Box>
//                     </GlassParentCard>
//                 )}
//             </Box>

//             {/* Group Search Dialog */}
//             <Dialog open={openSearchPopup && !showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
//                 <DialogContent sx={{ p: 3 }}>
//                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                         Search for Item Group: {selectedItemGroup}
//                     </Typography>

//                     <TextField fullWidth size="small" placeholder="Search by group name..." value={searchGroupQuery} onChange={(e) => handleSearchGroups(e.target.value)} sx={{ mb: 2 }}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon />
//                                 </InputAdornment>
//                             )
//                         }}
//                     />

//                     {searchLoading && (
//                         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                             <CircularProgress size={40} />
//                         </Box>
//                     )}

//                     {!searchLoading && searchResults.length > 0 && (
//                         <Box sx={{ maxHeight: 300, overflow: 'auto', mb: 2 }}>
//                             <Stack spacing={1}>
//                                 {searchResults.map((result) => (
//                                     <Paper
//                                         key={result.ProdGRPID}
//                                         onClick={() => {
//                                             if (result.IsPrimary === 1) {
//                                                 setSnackbar({ open: true, message: "Cannot select primary group. Select a non-primary group.", severity: "warning" });
//                                                 return;
//                                             }
//                                             handleSelectGroupFromSearch(result);
//                                         }}
//                                         sx={{ p: 2, bgcolor: result.IsPrimary === 1 ? '#f0f0f0' : '#f5f5f5', border: result.IsPrimary === 1 ? '1px solid #ccc' : '1px solid #e0e0e0', borderRadius: 2, cursor: result.IsPrimary === 1 ? 'not-allowed' : 'pointer', opacity: result.IsPrimary === 1 ? 0.6 : 1, transition: 'all 0.3s ease', '&:hover': { bgcolor: result.IsPrimary === 1 ? '#f0f0f0' : '#eeeeee' } }}
//                                     >
//                                         <Typography variant="body2" fontWeight={600}>
//                                             {result.GroupName}
//                                         </Typography>
//                                         {result.IsPrimary === 1 && (
//                                             <Typography variant="caption" sx={{ color: '#999' }}>
//                                                 (Primary Group - Not Selectable)
//                                             </Typography>
//                                         )}
//                                     </Paper>
//                                 ))}
//                             </Stack>
//                         </Box>
//                     )}

//                     {!searchLoading && searchGroupQuery && searchResults.length === 0 && (
//                         <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: 'center' }}>
//                             No groups found. Create a new one?
//                         </Typography>
//                     )}

//                     <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                         <Button variant="contained" color="success" onClick={handleOpenCreateGroupForm} startIcon={<AddCircleIcon />} >
//                             Add New Group
//                         </Button>
//                         <Button variant="outlined" color="error" onClick={handleCloseSearchPopup} >
//                             Cancel
//                         </Button>
//                     </Box>
//                 </DialogContent>
//             </Dialog>

//             {/* Create Group Dialog */}
//             {showCreateGroupForm && (
//                 <Dialog open={openSearchPopup && showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
//                     <DialogContent>
//                         <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
//                     </DialogContent>
//                 </Dialog>
//             )}

//             {/* Old Group Popup Dialog */}
//             <Dialog open={openGroupPopup} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth>
//                 <DialogContent>
//                     <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
//                 </DialogContent>
//             </Dialog>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%", fontSize: { xs: "0.85rem", sm: "0.95rem" }, fontWeight: 600, boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)" }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default InsertProduct;














// import React, { useState, useRef, useMemo, useEffect } from "react";
// import {
//     Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress,
//     Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, Dialog, DialogContent, useMediaQuery, useTheme
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import SearchIcon from '@mui/icons-material/Search';
// import BusinessIcon from '@mui/icons-material/Business';
// import InventoryIcon from '@mui/icons-material/Inventory';
// import PriceCheckIcon from '@mui/icons-material/PriceCheck';
// import WarningIcon from '@mui/icons-material/Warning';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import ProGroupMaster from './ProGroupMaster';
// import { useAuth } from '../context/AuthContext';

// // ✅ OPTIMIZATION: Simple ID generator with minimal overhead
// const generateUniqueId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

// const normalize = (s) => String(s || "").trim().toLowerCase();

// // Modern Glass Card with enhanced styling
// const GlassParentCard = ({ children }) => (
//     <Paper
//         elevation={0}
//         sx={{
//             borderRadius: { xs: 2, sm: 3, md: 4 }, background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`, backdropFilter: "blur(20px)", WebKitBackdropFilter: "blur(20px)", border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`, [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } }, boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)", position: "relative", overflow: "hidden", maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" }, display: "flex", flexDirection: "column",
//             "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`, },
//             "&::after": { content: '""', position: "absolute", top: 0, left: 0, width: 4, height: "100%", background: "linear-gradient(180deg, #1976d2, #42a5f5, transparent)", borderRadius: "0 8px 8px 0", }
//         }}
//     >
//         {children}
//     </Paper>
// );

// // Enhanced File Upload Zone
// const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [isDragOver, setIsDragOver] = useState(false);

//     const handleDragOver = (e) => {
//         e.preventDefault();
//         setIsDragOver(true);
//     };

//     const handleDragLeave = () => {
//         setIsDragOver(false);
//     };

//     const handleDrop = (e) => {
//         e.preventDefault();
//         setIsDragOver(false);
//         const droppedFiles = e.dataTransfer.files;
//         if (droppedFiles.length > 0) {
//             fileInputRef.current.files = droppedFiles;
//             const event = new Event('change', { bubbles: true });
//             Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
//             handleFileChange(event);
//         }
//     };

//     return (
//         <Box onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} sx={{ position: "relative", borderRadius: { xs: 2, sm: 3 }, border: `2px dashed ${isDragOver ? '#1976d2' : alpha('#1976d2', 0.3)}`, p: { xs: 2, sm: 3 }, textAlign: "center", transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", background: isDragOver ? alpha('#1976d2', 0.05) : alpha('#1976d2', 0.02), cursor: "pointer", "&:hover": { borderColor: '#1976d2', bgcolor: alpha('#1976d2', 0.04), }, display: "flex", alignItems: "center", justifyContent: "center", minHeight: { xs: 120, sm: 140 }, gap: 2, }} >
//             <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                 <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: '#1976d2', opacity: 0.7 }} />
//                 <Box>
//                     <Typography variant="body1" sx={{ fontWeight: 600, color: "#1976d2", fontSize: { xs: "0.95rem", sm: "1.1rem" }, mb: 0.5 }} >
//                         {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }} >
//                         Excel (.xlsx, .xls) or CSV files only
//                     </Typography>
//                 </Box>
//             </Box>

//             <Button variant="contained" onClick={(e) => { e.stopPropagation(); const hasError = data.some(r => r._missingFields?.length > 0); if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) { return; } fileInputRef.current.click(); }} sx={{ height: { xs: 36, sm: 40 }, bgcolor: "#1976d2", "&:hover": { bgcolor: "#115293" }, borderRadius: 1.5, textTransform: "none", fontWeight: 600, px: { xs: 2, sm: 2.5 }, whiteSpace: "nowrap", fontSize: { xs: "0.85rem", sm: "0.95rem" }, boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", transition: "all 0.3s ease", "&:hover": { bgcolor: "#115293", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)", transform: "translateY(-2px)" } }} >
//                 Browse
//             </Button>
//         </Box>
//     );
// };

// const InsertProduct = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState(null);
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [progressValue, setProgressValue] = useState(0);
//     const [bufferValue, setBufferValue] = useState(0);
//     const [showBuffer, setShowBuffer] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [searchText, setSearchText] = useState("");
//     const [expandedCards, setExpandedCards] = useState({});
//     const [filterMode, setFilterMode] = useState('all');
//     const [groupNames, setGroupNames] = useState([]);
//     const [openGroupPopup, setOpenGroupPopup] = useState(false);
//     const [selectedItemGroup, setSelectedItemGroup] = useState('');
//     const [selectedItemId, setSelectedItemId] = useState('');
//     const [openSearchPopup, setOpenSearchPopup] = useState(false);
//     const [searchGroupQuery, setSearchGroupQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [searchLoading, setSearchLoading] = useState(false);
//     const [showCreateGroupForm, setShowCreateGroupForm] = useState(false);
//     const [selectedGroupFromSearch, setSelectedGroupFromSearch] = useState(null);
//     const [selectedRowId, setSelectedRowId] = useState(null);
//     const [newlyCreatedGroupName, setNewlyCreatedGroupName] = useState(null);
//     const [groupCreatedFromPopup, setGroupCreatedFromPopup] = useState(false);
//     const [rowStatus, setRowStatus] = useState({});
//     const [fadeOutIds, setFadeOutIds] = useState(new Set());

//     // ✅ OPTIMIZATION: Increased parallel requests
//     const PARALLEL_REQUESTS = 10;
//     const abortControllerRef = useRef(null);

//     const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));

//     console.log("InsertProduct props:", { user, selectedCompany, connectionString });

//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     const userId = user?.UserId || null;
//     const branchId = selectedCompany?.[0]?.BranchId;
//     console.log("username:", user.UserName)

//     const fetchGroupNames = async () => {
//         try {
//             const response = await axios.get(`${path}/api/product-get-data/api/item-group`);
//             const groups = response.data;
//             setGroupNames(groups);
//             return groups;
//         } catch (error) {
//             console.error('Error fetching group names:', error);
//             setSnackbar({ open: true, message: "Error fetching group names", severity: "error" });
//         }
//     };

//     // ✅ OPTIMIZATION: Clear cache on component mount
//     useEffect(() => {
//         const clearCacheOnLoad = async () => {
//             try {
//                 console.log("Clearing cache on page load...");
//                 await axios.post(`${path}/api/product-clear-cache`, {}, {
//                     timeout: 5000
//                 });
//                 console.log("✅ Cache cleared on load");
//             } catch (error) {
//                 console.warn("⚠️ Cache clear on load failed (non-critical):", error.message);
//             }
//         };

//         clearCacheOnLoad();
//         fetchGroupNames();
//     }, [path]);

//     useEffect(() => {
//         const hasRedError = data.some(r => r._missingFields?.length > 0);
//         const handleBeforeUnload = (e) => {
//             if (hasRedError && data.length > 0) {
//                 e.preventDefault();
//                 e.returnValue = '';
//             }
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         return () => window.removeEventListener('beforeunload', handleBeforeUnload);
//     }, [data]);

//     const updateProgress = (value) => {
//         const clipped = Math.max(0, Math.min(100, value));
//         setProgressValue(clipped);
//         setBufferValue(Math.min(100, clipped + 10));
//     };

//     const hasFieldError = (record, fieldKey) => {
//         if (!record._missingFields) return false;
//         const fieldMap = {
//             PrimaryGroup: 'PrimaryGroup',
//             ItemGroup: 'itemGroup',
//             ItemCode: 'itemCode',
//             Description: 'description',
//             Specification: 'Specification',
//             ValueRate: 'ValRate',
//             Unit: 'unit',
//             HSN: 'HSN',
//             GST: 'GST',
//             applyStock: 'applyStock',
//             ApplyBatch: 'applyBatch',
//             Pkg: 'pkg',
//             ConvQty: 'Conversion Qty',
//             OpStock: 'Opening Stock',
//             SaleRate: 'Sale Rate',
//             SaleDiscount: 'Sale Discount (%)',
//             PurchaseRate: 'Purchase Rate',
//             PurchaseDiscount: 'Purchase Discount (%)',
//             MinLevel: 'Min Level',
//             MaxLevel: 'Max Level',
//             MinOrderQty: 'MOQ',
//             SelfLife: 'Self Life'
//         };
//         const errorLabel = fieldMap[fieldKey];
//         return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
//     };

//     const handleFileChange = async (e) => {
//         // ✅ OPTIMIZATION: Clear cache before processing new file
//         try {
//             await axios.post(`${path}/api/product-clear-cache`, {}, {
//                 timeout: 5000
//             });
//             console.log("Cache cleared before file processing");
//         } catch (error) {
//             console.warn("Cache clear before file processing failed (continuing anyway)");
//         }

//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             const validExtensions = [".xlsx", ".xls", ".csv"];
//             const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
//             if (!validExtensions.includes(fileExtension)) {
//                 setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
//                 setFile(null);
//                 setData([]);
//                 setFilteredData([]);
//                 fileInputRef.current.value = "";
//                 return;
//             }

//             setFile(selectedFile);
//             fileInputRef.current.value = null;

//             // Reset states
//             setData([]);
//             setFilteredData([]);
//             setRowStatus({});
//             setFadeOutIds(new Set());
//             setShowBuffer(true);
//             setFilterMode('all');
//             updateProgress(3);

//             // Clone file to force fresh read
//             const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
//             processFile(clonedFile);
//         }
//     };

//     const processFile = (file) => {
//         const reader = new FileReader();

//         reader.onprogress = (e) => {
//             if (e.lengthComputable) {
//                 const percentRead = Math.round((e.loaded / e.total) * 100);
//                 const mapped = Math.round(percentRead * 0.5);
//                 updateProgress(mapped);
//             }
//         };

//         reader.onload = (e) => {
//             try {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: "binary" });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const headers = jsonData[0] || [];

//                 // ✅ Build dynamic header index map
//                 const headerIndexMap = {};
//                 headers.forEach((h, i) => {
//                     if (h) headerIndexMap[String(h).trim()] = i;
//                 });

//                 // ✅ Only required columns must exist in file
//                 const requiredColumns = ["PrimaryGroup", "itemGroup", "itemCode", "description", "unit"];
//                 const missingColumns = requiredColumns.filter(col => headerIndexMap[col] === undefined);
//                 if (missingColumns.length > 0) {
//                     setSnackbar({
//                         open: true,
//                         message: `Missing required columns: ${missingColumns.join(", ")}`,
//                         severity: "error"
//                     });
//                     setData([]);
//                     setFilteredData([]);
//                     updateProgress(0);
//                     setShowBuffer(false);
//                     return;
//                 }

//                 const parseNumber = (val) => {
//                     if (val === null || val === undefined || val === "") return "";
//                     const num = parseFloat(String(val).trim());
//                     return isNaN(num) ? "INVALID" : num;
//                 };

//                 const requiredFields = [
//                     { key: 'PrimaryGroup', label: 'PrimaryGroup' },
//                     { key: 'ItemGroup', label: 'itemGroup' },
//                     { key: 'ItemCode', label: 'itemCode' },
//                     { key: 'Description', label: 'description' },
//                     { key: 'Unit', label: 'unit' }
//                 ];

//                 const yesValues = ['Yes', 'yes', 'Y', 'y'];
//                 const noValues = ['No', 'no', 'N', 'n'];

//                 // ✅ OPTIMIZATION: Process rows in chunks to avoid memory issues
//                 const CHUNK_SIZE = 500;
//                 const allParsedData = [];

//                 for (let chunkStart = 1; chunkStart < jsonData.length; chunkStart += CHUNK_SIZE) {
//                     const chunkEnd = Math.min(chunkStart + CHUNK_SIZE, jsonData.length);
//                     const chunk = jsonData.slice(chunkStart, chunkEnd);

//                     const parsedChunk = chunk.map((row, idx) => {
//                         // ✅ Helper to get value by column name dynamically
//                         const getVal = (colName) => {
//                             const i = headerIndexMap[colName];
//                             return i !== undefined ? (row[i] ?? "") : "";
//                         };

//                         const raw = {
//                             PrimaryGroup: String(getVal("PrimaryGroup") || "").trim(),
//                             ItemGroup: String(getVal("itemGroup") || "").trim(),
//                             applyStock: String(getVal("applyStock") || "").trim(),
//                             ApplyBatch: String(getVal("applyBatch") || "").trim(),
//                             ItemCode: String(getVal("itemCode") || "").trim(),
//                             Description: String(getVal("description") || "").trim(),
//                             Specification: String(getVal("Specification") || "").trim(),
//                             ValueRate: parseNumber(getVal("ValRate")),
//                             Unit: String(getVal("unit") || "").trim(),
//                             Pkg: parseNumber(getVal("pkg")),
//                             HSN: String(getVal("HSN") || "").trim(),
//                             GST: String(getVal("GST") || "").trim(),
//                             ConvUnit: String(getVal("convUnit") || "").trim(),
//                             ConvQty: parseNumber(getVal("convQty")),
//                             OpStock: parseNumber(getVal("opStock")),
//                             SaleRate: parseNumber(getVal("saleRate")),
//                             SaleDiscount: parseNumber(getVal("saleDiscount")),
//                             PurchaseRate: parseNumber(getVal("purchaseRate")),
//                             PurchaseDiscount: parseNumber(getVal("purchaseDiscount")),
//                             MinLevel: parseNumber(getVal("minLevel")),
//                             MaxLevel: parseNumber(getVal("maxLevel")),
//                             MinOrderQty: parseNumber(getVal("minOrderQty")),
//                             SelfLife: parseNumber(getVal("selfLife"))
//                         };

//                         const errors = [];

//                         requiredFields.forEach(f => {
//                             if (!raw[f.key]) {
//                                 errors.push(f.label);
//                             }
//                         });

//                         if (raw.applyStock && !yesValues.includes(raw.applyStock) && !noValues.includes(raw.applyStock)) {
//                             errors.push("applyStock (must be Yes/Y or No/N)");
//                         }
//                         if (raw.ApplyBatch && !yesValues.includes(raw.ApplyBatch) && !noValues.includes(raw.ApplyBatch)) {
//                             errors.push("applyBatch (must be Yes/Y or No/N)");
//                         }

//                         if (raw.Pkg === "INVALID") {
//                             errors.push("Pkg. (must be a number like 5 or 3.7)");
//                         }

//                         if (raw.GST && !/^\d+$/.test(raw.GST)) {
//                             errors.push("GST (must be integer like 10, 18, 28)");
//                         }

//                         if (raw.HSN) {
//                             const hsnDigits = raw.HSN.replace(/\D/g, '');
//                             const digitCount = hsnDigits.length;
//                             if (digitCount !== 4 && digitCount !== 6 && digitCount !== 8) {
//                                 errors.push("HSN (must be 4, 6, or 8 digits)");
//                             }
//                         }

//                         const numericFields = [
//                             { key: 'Pkg', label: 'Pkg.' },
//                             { key: 'ConvQty', label: 'Conversion Qty' },
//                             { key: 'OpStock', label: 'Opening Stock' },
//                             { key: 'SaleRate', label: 'Sale Rate' },
//                             { key: 'SaleDiscount', label: 'Sale Discount (%)' },
//                             { key: 'PurchaseRate', label: 'Purchase Rate' },
//                             { key: 'PurchaseDiscount', label: 'Purchase Discount (%)' },
//                             { key: 'MinLevel', label: 'Min Level' },
//                             { key: 'MaxLevel', label: 'Max Level' },
//                             { key: 'MinOrderQty', label: 'MOQ' },
//                             { key: 'SelfLife', label: 'Self Life' }
//                         ];

//                         numericFields.forEach(f => {
//                             const value = raw[f.key];
//                             if (value === "" || value === null) return;
//                             if (value === "INVALID" || isNaN(value)) {
//                                 errors.push(`${f.label} (must be a number like 5 or 3.4)`);
//                             }
//                         });

//                         const matchedGroup = groupNames.find(g =>
//                             normalize(g.GroupName) === normalize(raw.ItemGroup) &&
//                             g.IsPrimary === 0
//                         );

//                         const showAddIcon = !matchedGroup;

//                         const record = {
//                             id: generateUniqueId(),
//                             PrimaryGroup: raw.PrimaryGroup,
//                             ItemGroup: raw.ItemGroup,
//                             applyStock: raw.applyStock === "" ? 0 : yesValues.includes(raw.applyStock) ? 1 : noValues.includes(raw.applyStock) ? 0 : raw.applyStock,
//                             ApplyBatch: raw.ApplyBatch === "" ? 0 : yesValues.includes(raw.ApplyBatch) ? 1 : noValues.includes(raw.ApplyBatch) ? 0 : raw.ApplyBatch,
//                             ItemCode: raw.ItemCode,
//                             Description: raw.Description,
//                             Specification: raw.Specification,
//                             ValueRate: raw.ValueRate === "" || raw.ValueRate === "INVALID" ? 0 : raw.ValueRate,
//                             Unit: raw.Unit,
//                             Pkg: raw.Pkg === "" || raw.Pkg === "INVALID" ? 0 : raw.Pkg,
//                             HSN: raw.HSN ? raw.HSN.replace(/\D/g, '') : "",
//                             GST: raw.GST ? parseInt(raw.GST, 10) : 0,
//                             ConvQty: raw.ConvQty === "" || raw.ConvQty === "INVALID" ? 0 : raw.ConvQty,
//                             OpStock: raw.OpStock === "" || raw.OpStock === "INVALID" ? "" : raw.OpStock,
//                             SaleRate: raw.SaleRate === "" || raw.SaleRate === "INVALID" ? 0 : raw.SaleRate,
//                             SaleDiscount: raw.SaleDiscount === "" || raw.SaleDiscount === "INVALID" ? 0 : raw.SaleDiscount,
//                             PurchaseRate: raw.PurchaseRate === "" || raw.PurchaseRate === "INVALID" ? 0 : raw.PurchaseRate,
//                             PurchaseDiscount: raw.PurchaseDiscount === "" || raw.PurchaseDiscount === "INVALID" ? 0 : raw.PurchaseDiscount,
//                             MinLevel: raw.MinLevel === "" || raw.MinLevel === "INVALID" ? 0 : raw.MinLevel,
//                             MaxLevel: raw.MaxLevel === "" || raw.MaxLevel === "INVALID" ? 0 : raw.MaxLevel,
//                             MinOrderQty: raw.MinOrderQty === "" || raw.MinOrderQty === "INVALID" ? 0 : raw.MinOrderQty,
//                             SelfLife: raw.SelfLife === "" || raw.SelfLife === "INVALID" ? 0 : raw.SelfLife,
//                             ConvUnit: raw.ConvUnit,
//                             companyId,
//                             fYear,
//                             userId,
//                             _missingFields: errors,
//                             isGroupValid: !!matchedGroup,
//                             showAddIcon: showAddIcon,
//                             isGroupMissing: !matchedGroup,
//                             isGroupNotFound: !matchedGroup
//                         };

//                         return record;
//                     }).filter(row => row.ItemCode || row.Description || row.Unit);

//                     allParsedData.push(...parsedChunk);
//                 }

//                 setData(allParsedData);
//                 setFilteredData(allParsedData);
//                 setRowStatus({});
//                 setFadeOutIds(new Set());

//                 updateProgress(50);
//                 setSnackbar({ open: true, message: `Successfully parsed ${allParsedData.length} records`, severity: "success" });

//                 updateProgress(100);
//                 setTimeout(() => {
//                     setShowBuffer(false);
//                     updateProgress(0);
//                 }, 800);
//             } catch (err) {
//                 console.error(err);
//                 setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
//                 setData([]);
//                 setFilteredData([]);
//                 updateProgress(0);
//                 setShowBuffer(false);
//             }
//         };

//         reader.onerror = () => {
//             setSnackbar({ open: true, message: "Error reading file", severity: "error" });
//             setData([]);
//             setFilteredData([]);
//             updateProgress(0);
//             setShowBuffer(false);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const handleAddGroupClick = (itemGroup, rowId) => {
//         setSelectedItemGroup(itemGroup);
//         setSelectedRowId(rowId);
//         setOpenSearchPopup(true);
//         setSearchGroupQuery('');
//         setSearchResults([]);
//         setShowCreateGroupForm(false);
//     };

//     const handleSelectGroupFromSearch = async (selectedGroup) => {
//         try {
//             const groupsResponse = await axios.get(`${path}/api/product-get-data/api/item-group?companyId=${companyId}`);
//             const allGroups = groupsResponse.data;

//             let primaryGroupName = '';
//             if (selectedGroup.UnderGRP) {
//                 const primaryGroup = allGroups.find(g =>
//                     String(g.ProdGRPID) === String(selectedGroup.UnderGRP) &&
//                     g.IsPrimary === 1
//                 );
//                 if (primaryGroup) {
//                     primaryGroupName = primaryGroup.GroupName;
//                 }
//             }

//             const updateRowWithGroup = (rows) => {
//                 return rows.map(row => {
//                     if (row.id === selectedRowId) {
//                         return {
//                             ...row,
//                             ItemGroup: selectedGroup.GroupName,
//                             PrimaryGroup: primaryGroupName,
//                             isGroupValid: true,
//                             showAddIcon: false,
//                             isGroupMissing: false,
//                             isGroupNotFound: false,
//                             _missingFields: (row._missingFields || []).filter(
//                                 err => !err.toLowerCase().includes("group")
//                             )
//                         };
//                     }
//                     return row;
//                 });
//             };

//             setData(prevData => updateRowWithGroup(prevData));
//             setFilteredData(prevFilteredData => updateRowWithGroup(prevFilteredData));

//         } catch (error) {
//             console.error('Error selecting group:', error);
//             setSnackbar({ open: true, message: "Error selecting group", severity: "error" });
//         }

//         setOpenSearchPopup(false);
//         setSearchGroupQuery('');
//         setSearchResults([]);
//         setShowCreateGroupForm(false);
//         setSelectedRowId(null);
//     };

//     const handleSearchGroups = async (searchText) => {
//         setSearchGroupQuery(searchText);

//         if (!searchText.trim()) {
//             setSearchResults([]);
//             return;
//         }

//         try {
//             setSearchLoading(true);
//             const params = {
//                 GroupCode: searchText,
//                 companyId: companyId,
//                 mode: 'search'
//             };

//             const dataRes = await axios.get(`${path}/api/group/search`, { params });
//             setSearchResults(dataRes.data || []);
//         } catch (error) {
//             console.error('Error searching groups:', error);
//             setSnackbar({ open: true, message: "Error searching groups", severity: "error" });
//             setSearchResults([]);
//         } finally {
//             setSearchLoading(false);
//         }
//     };

//     const handleOpenCreateGroupForm = () => {
//         setShowCreateGroupForm(true);
//         setOpenSearchPopup(true);
//     };

//     const handleCloseSearchPopup = async (meta) => {
//         const createdGroupName = meta?.created ? meta.groupName : null;
//         if (meta?.created) setGroupCreatedFromPopup(true);

//         try {
//             if (selectedGroupFromSearch && selectedRowId) {
//                 const { data: allGroups } = await axios.get(
//                     `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
//                 );

//                 let primaryGroupName = '';

//                 if (selectedGroupFromSearch.UnderGRP) {
//                     const primary = allGroups.find(
//                         g =>
//                             String(g.ProdGRPID) === String(selectedGroupFromSearch.UnderGRP) &&
//                             g.IsPrimary === 1
//                     );
//                     if (primary) primaryGroupName = primary.GroupName;
//                 }

//                 const patchRow = rows =>
//                     rows.map(row =>
//                         row.id === selectedRowId
//                             ? {
//                                 ...row,
//                                 ItemGroup: selectedGroupFromSearch.GroupName,
//                                 PrimaryGroup: primaryGroupName,
//                                 isGroupValid: true,
//                                 showAddIcon: false,
//                                 isGroupMissing: false,
//                                 isGroupNotFound: false,
//                                 _missingFields: (row._missingFields || []).filter(
//                                     err => !err.toLowerCase().includes("group")
//                                 )
//                             }
//                             : row
//                     );

//                 setData(prev => patchRow(prev));
//                 setFilteredData(prev => patchRow(prev));
//             } else if ((createdGroupName || groupCreatedFromPopup) && selectedRowId) {
//                 const groupNameToMatch = createdGroupName || selectedItemGroup;

//                 const { data: allGroups } = await axios.get(
//                     `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
//                 );

//                 const newlyCreatedGroup = allGroups.find(
//                     g =>
//                         normalize(g.GroupName) === normalize(groupNameToMatch) &&
//                         g.IsPrimary === 0 &&
//                         g.UnderGRP
//                 );

//                 if (newlyCreatedGroup) {
//                     let primaryGroupName = '';

//                     const primary = allGroups.find(
//                         g =>
//                             String(g.ProdGRPID) === String(newlyCreatedGroup.UnderGRP) &&
//                             g.IsPrimary === 1
//                     );

//                     if (primary) primaryGroupName = primary.GroupName;

//                     const patchRow = rows =>
//                         rows.map(row =>
//                             row.id === selectedRowId
//                                 ? {
//                                     ...row,
//                                     ItemGroup: newlyCreatedGroup.GroupName,
//                                     PrimaryGroup: primaryGroupName,
//                                     isGroupValid: true,
//                                     showAddIcon: false,
//                                     isGroupMissing: false,
//                                     isGroupNotFound: false,
//                                     _missingFields: (row._missingFields || []).filter(
//                                         err => !err.toLowerCase().includes("group")
//                                     )
//                                 }
//                                 : row
//                         );

//                     setData(prev => patchRow(prev));
//                     setFilteredData(prev => patchRow(prev));
//                 }
//             }

//             const updatedGroups = await fetchGroupNames();

//             setData(prev =>
//                 prev.map(row => {
//                     const matched = updatedGroups.find(
//                         g =>
//                             normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                             g.IsPrimary === 0
//                     );

//                     if (!matched) return row;

//                     let primaryGroupName = row.PrimaryGroup;

//                     if (matched.UnderGRP) {
//                         const primary = updatedGroups.find(
//                             g =>
//                                 String(g.ProdGRPID) === String(matched.UnderGRP) &&
//                                 g.IsPrimary === 1
//                         );
//                         if (primary) primaryGroupName = primary.GroupName;
//                     }

//                     return {
//                         ...row,
//                         ItemGroup: matched.GroupName,
//                         PrimaryGroup: primaryGroupName,
//                         isGroupValid: true,
//                         showAddIcon: false,
//                         isGroupMissing: false,
//                         isGroupNotFound: false
//                     };
//                 })
//             );

//             setFilteredData(prev =>
//                 prev.map(row => {
//                     const matched = updatedGroups.find(
//                         g =>
//                             normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                             g.IsPrimary === 0
//                     );

//                     if (!matched) return row;

//                     let primaryGroupName = row.PrimaryGroup;

//                     if (matched.UnderGRP) {
//                         const primary = updatedGroups.find(
//                             g =>
//                                 String(g.ProdGRPID) === String(matched.UnderGRP) &&
//                                 g.IsPrimary === 1
//                         );
//                         if (primary) primaryGroupName = primary.GroupName;
//                     }

//                     return {
//                         ...row,
//                         ItemGroup: matched.GroupName,
//                         PrimaryGroup: primaryGroupName,
//                         isGroupValid: true,
//                         showAddIcon: false,
//                         isGroupMissing: false,
//                         isGroupNotFound: false
//                     };
//                 })
//             );
//         } catch (error) {
//             console.error('handleCloseSearchPopup error:', error);
//             setSnackbar({
//                 open: true,
//                 message: 'Error resolving Item Group',
//                 severity: 'error'
//             });
//         } finally {
//             setOpenSearchPopup(false);
//             setSearchGroupQuery('');
//             setSearchResults([]);
//             setShowCreateGroupForm(false);
//             setSelectedGroupFromSearch(null);
//             setSelectedRowId(null);
//             setGroupCreatedFromPopup(false);
//         }
//     };

//     useEffect(() => {
//         if (!groupNames.length || !data.length) return;

//         setData(prev => prev.map(row => {
//             const m = groupNames.find(g =>
//                 normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                 g.IsPrimary === 0
//             );
//             return { ...row, showAddIcon: !m };
//         }));
//     }, [groupNames]);

//     const handleGroupPopupClose = async () => {
//         setOpenGroupPopup(false);
//         setSelectedItemGroup('');

//         const updatedGroups = await fetchGroupNames();

//         setData(prevData =>
//             prevData.map(row => {
//                 const matchedGroup = updatedGroups.find(g =>
//                     normalize(g.GroupName) === normalize(row.ItemGroup) &&
//                     g.IsPrimary === 0
//                 );

//                 const shouldShowAddIcon = !matchedGroup;

//                 let primaryGroupName = row.PrimaryGroup;
//                 let itemGroupName = row.ItemGroup;

//                 if (matchedGroup) {
//                     itemGroupName = matchedGroup.GroupName;

//                     if (matchedGroup.UnderGRP) {
//                         const primaryGroup = updatedGroups.find(g =>
//                             String(g.ProdGRPID) === String(matchedGroup.UnderGRP) &&
//                             g.IsPrimary === 1
//                         );
//                         if (primaryGroup) {
//                             primaryGroupName = primaryGroup.GroupName;
//                         }
//                     }
//                 }

//                 return {
//                     ...row,
//                     PrimaryGroup: primaryGroupName,
//                     ItemGroup: itemGroupName,
//                     isGroupValid: !!matchedGroup && matchedGroup.IsPrimary === 0,
//                     showAddIcon: shouldShowAddIcon
//                 };
//             })
//         );
//     };

//     // ✅ OPTIMIZATION: Process requests in parallel batches with error handling
//     const handleUploadSubmit = async () => {
//         if (!data.length) {
//             setSnackbar({ open: true, message: "No data to upload", severity: "error" });
//             return;
//         }

//         const validRows = data.filter(r =>
//             (!r._missingFields || r._missingFields.length === 0) &&
//             !r.isGroupNotFound
//         );
//         const errorRows = data.filter(r => r._missingFields?.length > 0);

//         if (validRows.length === 0) {
//             setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
//             return;
//         }

//         if (!companyId || !userId) {
//             setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
//             return;
//         }

//         setUploading(true);
//         setShowBuffer(true);
//         updateProgress(0);

//         let insertedCount = 0;
//         let existsCount = 0;
//         let notModifiedCount = 0;
//         let failedCount = 0;
//         const processedRowIds = [];

//         try {
//             // ✅ OPTIMIZATION: Process in parallel batches
//             const batchSize = PARALLEL_REQUESTS;
//             const totalBatches = Math.ceil(validRows.length / batchSize);

//             for (let batchIdx = 0; batchIdx < totalBatches; batchIdx++) {
//                 const startIdx = batchIdx * batchSize;
//                 const endIdx = Math.min(startIdx + batchSize, validRows.length);
//                 const batchRows = validRows.slice(startIdx, endIdx);

//                 const promises = batchRows.map(async (row) => {
//                     const payload = {
//                         GroupId: '',
//                         itemGroup: row.ItemGroup,
//                         inStock: row.applyStock === 1 || row.applyStock === "1" ? 1 : 0,
//                         applyBatch: row.ApplyBatch === 1 || row.ApplyBatch === "1" ? 1 : 0,
//                         itemCode: row.ItemCode,
//                         description: row.Description,
//                         specification: row.Specification,
//                         valueRate: row.ValueRate,
//                         unit: row.Unit,
//                         pkg: row.Pkg || 0,
//                         HSN: row.HSN,
//                         GST: row.GST,
//                         optionalBalance: row.OpStock,
//                         saleRate: row.SaleRate,
//                         saleDiscount: row.SaleDiscount,
//                         purchaseRate: row.PurchaseRate,
//                         purchaseDiscount: row.PurchaseDiscount,
//                         convUnit: row.ConvUnit || "",
//                         convQty: row.ConvQty,
//                         minLevel: row.MinLevel,
//                         maxLevel: row.MaxLevel,
//                         minOrderQty: row.MinOrderQty,
//                         selfLife: row.SelfLife,
//                         companyId,
//                         addUserId: userId,
//                         addUserDateTime: new Date().toISOString(),
//                         branchId,
//                         groupOfCompanyId: companyId
//                     };

//                     try {
//                         const response = await axios.post(`${path}/api/product-bulk-Insert`, payload, {
//                             validateStatus: (status) => [200, 201, 204, 304, 500].includes(status),
//                             timeout: 30000 // ✅ Add timeout
//                         });

//                         const status = response.status;
//                         let message = "";
//                         let severity = "error";

//                         if (status === 201) {
//                             message = "Inserted";
//                             insertedCount++;
//                             severity = "success";
//                         } else if (status === 204) {
//                             message = "Already Exists";
//                             existsCount++;
//                             severity = "warning";
//                         } else if (status === 304) {
//                             message = "Group not found";
//                             notModifiedCount++;
//                             severity = "warning";
//                         } else if (status === 500) {
//                             message = "Server Error";
//                             failedCount++;
//                             severity = "error";
//                         }

//                         setRowStatus(prev => ({
//                             ...prev,
//                             [row.id]: { status, message, severity }
//                         }));

//                         if (status === 201 || status === 204) {
//                             processedRowIds.push(row.id);
//                         }

//                         console.log(`Row - Status: ${status} - ${message}`);
//                     } catch (err) {
//                         const status = err.response?.status || 500;
//                         const message = status === 500 ? "Server Error" : "Failed";
//                         failedCount++;
//                         setRowStatus(prev => ({
//                             ...prev,
//                             [row.id]: { status, message, severity: "error" }
//                         }));
//                         console.error(`Row error:`, err.message);
//                     }
//                 });

//                 // Wait for all promises in this batch
//                 await Promise.all(promises);

//                 // Update progress
//                 const progress = 50 + Math.round(((endIdx) / validRows.length) * 50);
//                 updateProgress(progress);
//             }

//             const parts = [];
//             if (insertedCount) parts.push(`${insertedCount} Inserted`);
//             if (existsCount) parts.push(`${existsCount} Already Exists`);
//             if (notModifiedCount) parts.push(`${notModifiedCount} Not Modified`);
//             if (failedCount) parts.push(`${failedCount} Failed`);
//             if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

//             setSnackbar({
//                 open: true,
//                 message: parts.join(" | "),
//                 severity: insertedCount > 0 ? "success" : "warning"
//             });

//             // ✅ OPTIMIZATION: Clear cache after successful upload
//             setTimeout(async () => {
//                 try {
//                     await axios.post(`${path}/api/product-clear-cache`, {}, {
//                         timeout: 5000
//                     });
//                     console.log("✅ Cache cleared after upload");
//                 } catch (error) {
//                     console.error("Cache clear after upload failed:", error);
//                 }

//                 const sortedFadeIds = processedRowIds
//                     .map(id => ({ id, group: data.find(r => r.id === id)?.ItemGroup || "" }))
//                     .sort((a, b) => (a.group || "").localeCompare(b.group || ""))
//                     .map(item => item.id);

//                 sortedFadeIds.forEach((id, index) => {
//                     setTimeout(() => {
//                         setFadeOutIds(prev => new Set(prev).add(id));
//                     }, index * 500); // ✅ Reduced fade delay
//                 });

//                 setTimeout(() => {
//                     setData(prev => prev.filter(r => !processedRowIds.includes(r.id)));
//                     setRowStatus({});
//                     setFadeOutIds(new Set());
//                 }, sortedFadeIds.length * 500 + 600);
//             }, 3000); // ✅ Reduced wait time

//         } catch (error) {
//             console.error("Unexpected error:", error);
//             setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
//         } finally {
//             setUploading(false);
//             setShowBuffer(false);
//             updateProgress(0);
//         }
//     };

//     const handleBackClick = () => { navigate("/main/productMaster"); };

//     const sortedData = useMemo(() => {
//         const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
//         const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

//         const groupNotFound = withoutError.filter(r => r.isGroupNotFound);
//         const validRows = withoutError.filter(r => !r.isGroupNotFound);

//         const sortByItemGroup = (a, b) => {
//             const groupA = (a.ItemGroup || "").trim().toLowerCase();
//             const groupB = (b.ItemGroup || "").trim().toLowerCase();
//             return groupA.localeCompare(groupB);
//         };

//         const sortedWithError = [...withError].sort(sortByItemGroup);
//         const sortedGroupNotFound = [...groupNotFound].sort(sortByItemGroup);
//         const sortedValid = [...validRows].sort(sortByItemGroup);

//         return [...sortedWithError, ...sortedGroupNotFound, ...sortedValid];
//     }, [data]);

//     const filteredDataFinal = useMemo(() => {
//         let result = sortedData;

//         if (filterMode === 'perfect') {
//             result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
//         } else if (filterMode === 'error') {
//             result = result.filter(r => r._missingFields?.length > 0);
//         }

//         if (searchText.trim()) {
//             const lowerSearch = searchText.toLowerCase();
//             result = result.filter(row =>
//                 row.Description?.toLowerCase().includes(lowerSearch) ||
//                 row.ItemCode?.toLowerCase().includes(lowerSearch) ||
//                 row.Unit?.toLowerCase().includes(lowerSearch)
//             );
//         }

//         return result;
//     }, [sortedData, filterMode, searchText]);

//     useMemo(() => {
//         setFilteredData(filteredDataFinal);
//     }, [filteredDataFinal]);

//     const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
//     const perfectCount = useMemo(() => data.length - errorCount, [data]);
//     const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

//     const fieldGroups = [
//         {
//             title: "Basic Info",
//             icon: <BusinessIcon fontSize="small" />,
//             fields: [
//                 { label: "Primary Group", key: "PrimaryGroup" },
//                 { label: "Item Group", key: "ItemGroup" },
//                 { label: "applyStock", key: "applyStock" },
//                 { label: "applyBatch", key: "ApplyBatch" },
//                 { label: "Item Code", key: "ItemCode" },
//                 { label: "Description", key: "Description" },
//                 { label: "Specification", key: "Specification" },
//                 { label: "Value Rate", key: "ValueRate" },
//                 { label: "Unit", key: "Unit" },
//                 { label: "Pkg.", key: "Pkg" },
//                 { label: "HSN", key: "HSN" },
//                 { label: "GST", key: "GST" },
//             ]
//         },
//         {
//             title: "Conversion & Stock",
//             icon: <InventoryIcon fontSize="small" />,
//             fields: [
//                 { label: "Conversion Unit", key: "ConvUnit" },
//                 { label: "Conversion Qty", key: "ConvQty" },
//                 { label: "Opening Stock", key: "OpStock" },
//                 { label: "Min Level", key: "MinLevel" },
//                 { label: "Max Level", key: "MaxLevel" },
//                 { label: "MOQ", key: "MinOrderQty" },
//                 { label: "Self Life", key: "SelfLife" },
//             ]
//         },
//         {
//             title: "Pricing",
//             icon: <PriceCheckIcon fontSize="small" />,
//             fields: [
//                 { label: "Sale Rate", key: "SaleRate" },
//                 { label: "Sale Discount (%)", key: "SaleDiscount" },
//                 { label: "Purchase Rate", key: "PurchaseRate" },
//                 { label: "Purchase Discount (%)", key: "PurchaseDiscount" },
//             ]
//         }
//     ];

//     return (
//         <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
//             {/* Header Section with enhanced styling */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
//                 <Box>
//                     <Typography variant="h4" sx={{ fontWeight: 700, background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" }, letterSpacing: "-0.5px" }} >
//                         Product Data Upload
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} >
//                         Manage and import your product information
//                     </Typography>
//                 </Box>
//                 <Tooltip title="Back to Product Master" placement="left">
//                     <IconButton onClick={handleBackClick} sx={{ bgcolor: "#1976d2", color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, "&:hover": { bgcolor: "#115293", transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)" }, borderRadius: 1.5, transition: "all 0.3s ease", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", flexShrink: 0 }} >
//                         <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
//                     </IconButton>
//                 </Tooltip>
//             </Box>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//                 {/* File Upload Card */}
//                 <Paper sx={{ px: { xs: 3, sm: 3.5 }, py: { xs: 2, sm: 2.5 }, borderRadius: { xs: 2.5, sm: 3 }, bgcolor: "background.paper", boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)", border: `1px solid ${alpha('#1976d2', 0.1)}`, position: "relative", overflow: "hidden", "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`, } }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                         {/* File Upload Zone */}
//                         <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

//                         {/* Upload Controls & Progress */}
//                         {(file || data.length > 0) && (
//                             <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
//                                 <Button variant="contained" onClick={handleUploadSubmit} disabled={uploading || !data.length || validRowsCount === 0} sx={{ height: { xs: 40, sm: 44 }, bgcolor: "#1976d2", "&:hover": { bgcolor: "#115293", boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)", transform: "translateY(-2px)" }, borderRadius: 1.5, textTransform: "none", fontWeight: 700, px: { xs: 2, sm: 3 }, "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" }, fontSize: { xs: "0.95rem", sm: "1.05rem" }, minWidth: { xs: "auto", sm: 140 }, transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", gap: 1 }} >
//                                     {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
//                                     {uploading ? "Uploading..." : "Upload Records"}
//                                 </Button>
//                                 {showBuffer && (
//                                     <Box sx={{ width: { xs: "100%", sm: 280 } }}>
//                                         <LinearProgress variant="buffer" value={progressValue} valueBuffer={bufferValue} sx={{ height: 4, borderRadius: 4, backgroundColor: alpha('#1976d2', 0.1), "& .MuiLinearProgress-bar": { borderRadius: 4, background: "linear-gradient(90deg, #1976d2, #42a5f5)" } }} />
//                                         <Typography variant="caption" sx={{ display: "block", textAlign: "center", fontSize: { xs: "0.75rem", sm: "0.85rem" }, fontWeight: 600, color: "#1976d2" }} >
//                                             {uploading ? `${Math.round(progressValue)}%` : `Ready`}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>
//                         )}

//                         {/* Statistics Chips */}
//                         {data.length > 0 && (
//                             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
//                                 <Chip icon={<CheckCircleIcon sx={{ fontSize: 18 }} />} label={`${perfectCount} Valid`} onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')} variant={filterMode === 'perfect' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'perfect' ? '#4caf50' : 'transparent', color: filterMode === 'perfect' ? 'white' : '#4caf50', fontWeight: 700, border: filterMode === 'perfect' ? 'none' : '2px solid #4caf50', cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha('#4caf50', 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
//                                 <Chip icon={<ErrorIcon sx={{ fontSize: 18 }} />} label={`${errorCount} Errors`} onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')} variant={filterMode === 'error' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'error' ? '#f44336' : 'transparent', color: filterMode === 'error' ? 'white' : '#f44336', fontWeight: 700, border: filterMode === 'error' ? 'none' : '2px solid #f44336', cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'error' ? '#d32f2f' : alpha('#f44336', 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>

//                 {/* Data Display Section */}
//                 {data.length > 0 && (
//                     <GlassParentCard>
//                         {/* Search Bar */}
//                         <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
//                             <TextField fullWidth size="small" placeholder={isMobile ? "Search products..." : "Search by description, code, unit..."} value={searchText} onChange={(e) => setSearchText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon sx={{ fontSize: 22, color: "#1976d2" }} />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.paper", fontSize: { xs: "0.9rem", sm: "1rem" }, border: `1.5px solid ${alpha('#1976d2', 0.2)}`, transition: "all 0.3s ease", "&:hover": { borderColor: alpha('#1976d2', 0.4) }, "&.Mui-focused": { borderColor: "#1976d2", boxShadow: `0 0 0 3px ${alpha('#1976d2', 0.1)}` } } }}
//                             />
//                         </Box>

//                         {/* Records Container */}
//                         <Box flex={1} overflow="auto" p={{ xs: 1.5, sm: 2 }} pt={0} sx={{ maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" }, '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-track': { background: alpha('#1976d2', 0.05), borderRadius: '10px' }, '&::-webkit-scrollbar-thumb': { background: '#1976d2', borderRadius: '10px', '&:hover': { background: '#115293' } } }} >
//                             <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
//                                 {filteredData.length === 0 ? (
//                                     <Paper sx={{ p: 2.5, textAlign: "center", borderRadius: 3, bgcolor: alpha("#1976d2", 0.02), border: `1px dashed ${alpha("#1976d2", 0.2)}` }}>
//                                         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                                             <SearchIcon sx={{ fontSize: 48, color: alpha("#1976d2", 0.3), mb: 1 }} />
//                                             <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
//                                                 {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
//                                             </Typography>
//                                         </Box>
//                                     </Paper>
//                                 ) : (
//                                     filteredData.map((r, idx) => {
//                                         const missing = r._missingFields || [];
//                                         const isError = missing.length > 0;
//                                         const expanded = expandedCards[r.id];
//                                         const statusInfo = rowStatus[r.id];
//                                         const isFading = fadeOutIds.has(r.id);

//                                         let cardBg = "background.paper";
//                                         let borderColor = alpha('#1976d2', 0.2);
//                                         let statusChip = null;

//                                         if (statusInfo) {
//                                             if (statusInfo.status === 201) {
//                                                 cardBg = "#e8f5e9";
//                                                 borderColor = "#4caf50";
//                                                 statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
//                                             } else if ([204, 304].includes(statusInfo.status)) {
//                                                 cardBg = "#fff8e1";
//                                                 borderColor = "#ffb300";
//                                                 const label = statusInfo.status === 204 ? "Already Exists" : "Group not found";
//                                                 statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label };
//                                             } else {
//                                                 cardBg = "#ffebee";
//                                                 borderColor = "#f44336";
//                                                 statusChip = { color: "#c62828", bg: "#f44336", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
//                                             }
//                                         } else if (isError) {
//                                             cardBg = "#ffebee";
//                                             borderColor = "#f44336";
//                                         }

//                                         return (
//                                             <Card key={r.id} elevation={isError ? 4 : 2} sx={{ borderRadius: { xs: 2, sm: 2.5, md: 3 }, bgcolor: cardBg, border: `2px solid ${borderColor}`, position: "relative", overflow: "visible", transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", opacity: isFading ? 0 : 1, transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)", height: isFading ? 0 : "auto", marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 }, padding: isFading ? 0 : { xs: 1, sm: 1.5 }, "&:hover": { boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)", } }} >
//                                                 {statusChip && !isFading && (
//                                                     <Box sx={{ position: "absolute", bottom: 8, right: 12, bgcolor: statusChip.bg, color: statusChip.bg === '#ffb300' ? '#000' : 'white', px: 1.25, py: 0.4, borderRadius: 1.5, fontSize: { xs: "0.7rem", sm: "0.8rem" }, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5, zIndex: 1, boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}` }} >
//                                                         {statusChip.icon}
//                                                         {statusChip.label}
//                                                     </Box>
//                                                 )}

//                                                 <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
//                                                     {/* Main Header Row */}
//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: { xs: 1.5, sm: 2, md: 4 }, flexWrap: { xs: "wrap", sm: "nowrap" } }} >
//                                                         {/* Item Info */}
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
//                                                             <Box sx={{ background: statusInfo?.status === 201 ? "linear-gradient(135deg, #4caf50, #66bb6a)" : (isError ? "linear-gradient(135deg, #f44336, #ef5350)" : "linear-gradient(135deg, #1976d2, #42a5f5)"), color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0, fontSize: { xs: "1.1rem", sm: "1.3rem" }, boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }} >
//                                                                 {r.ItemGroup?.[0]?.toUpperCase() || "?"}
//                                                             </Box>
//                                                             <Box sx={{ minWidth: 0, flex: 1 }}>
//                                                                 <Typography variant="h6" fontWeight={700} noWrap sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }} >
//                                                                     {r.ItemGroup || "Unnamed"}
//                                                                 </Typography>
//                                                                 <Typography variant="body2" color="text.secondary" noWrap sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }} >
//                                                                     {r.ItemCode || "—"} • {r.Unit || "—"}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </Box>

//                                                         {/* Quick Info - Responsive Grid */}
//                                                         <Box sx={{ display: 'grid', gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: { xs: 1.25, sm: 1.75 }, alignItems: 'flex-start', flex: { xs: "0 0 100%", sm: "auto" }, width: { xs: "100%", sm: "auto" } }} >
//                                                             {[
//                                                                 { label: "HSN", value: r.HSN || "—", key: "HSN", icon: "📍" },
//                                                                 { label: "GST", value: r.GST || "—", key: "GST", icon: "🏛️" },
//                                                                 { label: "Sale Rate", value: r.SaleRate || "—", key: "SaleRate", icon: "💰" },
//                                                                 { label: "Group", value: r.ItemGroup || "—", key: "ItemGroup", icon: "📦" }
//                                                             ].map((item, i) => {
//                                                                 const hasErr = hasFieldError(r, item.key);
//                                                                 return (
//                                                                     <Box key={i} sx={{ bgcolor: hasErr ? alpha('#f44336', 0.08) : alpha('#1976d2', 0.04), borderRadius: 1.5, p: 1, transition: 'all 0.2s ease', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0, border: `1px solid ${hasErr ? alpha('#f44336', 0.2) : alpha('#1976d2', 0.1)}` }} >
//                                                                         <Typography variant="caption" sx={{ fontWeight: 700, color: hasErr ? '#f44336' : 'text.secondary', lineHeight: 1.3, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.5px" }} >
//                                                                             {item.label}
//                                                                         </Typography>
//                                                                         <Typography variant="body2" fontWeight={600} noWrap sx={{ mt: 0.4, wordBreak: 'break-word', maxWidth: '100%', fontSize: { xs: "0.75rem", sm: "0.9rem" }, color: "#000" }} >
//                                                                             {item.value}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                 );
//                                                             })}
//                                                         </Box>

//                                                         {/* Actions - Expand + Add Group Button */}
//                                                         <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'flex-start', flexShrink: 0 }}>
//                                                             {r.showAddIcon && (
//                                                                 <Tooltip title="Add this Item Group">
//                                                                     <IconButton onClick={() => handleAddGroupClick(r.ItemGroup, r.id)} sx={{ bgcolor: "#4caf50", color: "white", width: { xs: 36, sm: 40 }, height: { xs: 36, sm: 40 }, "&:hover": { bgcolor: "#388e3c", transform: 'scale(1.1)', boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)" }, borderRadius: 1.5, transition: 'all 0.3s ease', flexShrink: 0 }} >
//                                                                         <AddCircleIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
//                                                                     </IconButton>
//                                                                 </Tooltip>
//                                                             )}
//                                                             <IconButton size="small" onClick={() => toggleExpand(r.id)} sx={{ alignSelf: 'flex-start', flexShrink: 0, bgcolor: alpha('#1976d2', 0.1), color: '#1976d2', width: { xs: 36, sm: 40 }, height: { xs: 36, sm: 40 }, transition: 'all 0.3s ease', "&:hover": { bgcolor: alpha('#1976d2', 0.2), transform: 'scale(1.1)' } }} >
//                                                                 {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
//                                                             </IconButton>
//                                                         </Box>
//                                                     </Box>

//                                                     {/* Expanded Details */}
//                                                     <Collapse in={expanded} timeout="auto" unmountOnExit>
//                                                         <Divider sx={{ my: 1.5 }} />
//                                                         <Box mt={1.5}>
//                                                             {fieldGroups.map((group, gIdx) => (
//                                                                 <Box key={gIdx} mb={2}>
//                                                                     <Typography variant="subtitle2" color="primary" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: { xs: "0.85rem", sm: "1rem" }, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px" }} >
//                                                                         {group.icon} {group.title}
//                                                                     </Typography>
//                                                                     <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                                                         {group.fields.map((f, fIdx) => (
//                                                                             <Grid item xs={12} sm={6} key={fIdx}>
//                                                                                 <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha('#1976d2', 0.02), border: `1px solid ${alpha('#1976d2', 0.1)}` }}>
//                                                                                     <Typography variant="caption" sx={{ color: hasFieldError(r, f.key) ? '#f44336' : 'text.secondary', fontWeight: hasFieldError(r, f.key) ? 700 : 600, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.3px" }} >
//                                                                                         {f.label}
//                                                                                     </Typography>
//                                                                                     <Typography variant="body2" fontWeight={600} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }} >
//                                                                                         {r[f.key] || "—"}
//                                                                                     </Typography>
//                                                                                 </Box>
//                                                                             </Grid>
//                                                                         ))}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Collapse>
//                                                 </CardContent>
//                                             </Card>
//                                         );
//                                     })
//                                 )}
//                             </Stack>
//                         </Box>
//                     </GlassParentCard>
//                 )}
//             </Box>

//             {/* Group Search Dialog */}
//             <Dialog open={openSearchPopup && !showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
//                 <DialogContent sx={{ p: 3 }}>
//                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                         Search for Item Group: {selectedItemGroup}
//                     </Typography>

//                     <TextField fullWidth size="small" placeholder="Search by group name..." value={searchGroupQuery} onChange={(e) => handleSearchGroups(e.target.value)} sx={{ mb: 2 }}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon />
//                                 </InputAdornment>
//                             )
//                         }}
//                     />

//                     {searchLoading && (
//                         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                             <CircularProgress size={40} />
//                         </Box>
//                     )}

//                     {!searchLoading && searchResults.length > 0 && (
//                         <Box sx={{ maxHeight: 300, overflow: 'auto', mb: 2 }}>
//                             <Stack spacing={1}>
//                                 {searchResults.map((result) => (
//                                     <Paper
//                                         key={result.ProdGRPID}
//                                         onClick={() => {
//                                             if (result.IsPrimary === 1) {
//                                                 setSnackbar({ open: true, message: "Cannot select primary group. Select a non-primary group.", severity: "warning" });
//                                                 return;
//                                             }
//                                             handleSelectGroupFromSearch(result);
//                                         }}
//                                         sx={{ p: 2, bgcolor: result.IsPrimary === 1 ? '#f0f0f0' : '#f5f5f5', border: result.IsPrimary === 1 ? '1px solid #ccc' : '1px solid #e0e0e0', borderRadius: 2, cursor: result.IsPrimary === 1 ? 'not-allowed' : 'pointer', opacity: result.IsPrimary === 1 ? 0.6 : 1, transition: 'all 0.3s ease', '&:hover': { bgcolor: result.IsPrimary === 1 ? '#f0f0f0' : '#eeeeee' } }}
//                                     >
//                                         <Typography variant="body2" fontWeight={600}>
//                                             {result.GroupName}
//                                         </Typography>
//                                         {result.IsPrimary === 1 && (
//                                             <Typography variant="caption" sx={{ color: '#999' }}>
//                                                 (Primary Group - Not Selectable)
//                                             </Typography>
//                                         )}
//                                     </Paper>
//                                 ))}
//                             </Stack>
//                         </Box>
//                     )}

//                     {!searchLoading && searchGroupQuery && searchResults.length === 0 && (
//                         <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: 'center' }}>
//                             No groups found. Create a new one?
//                         </Typography>
//                     )}

//                     <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                         <Button variant="contained" color="success" onClick={handleOpenCreateGroupForm} startIcon={<AddCircleIcon />} >
//                             Add New Group
//                         </Button>
//                         <Button variant="outlined" color="error" onClick={handleCloseSearchPopup} >
//                             Cancel
//                         </Button>
//                     </Box>
//                 </DialogContent>
//             </Dialog>

//             {/* Create Group Dialog */}
//             {showCreateGroupForm && (
//                 <Dialog open={openSearchPopup && showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
//                     <DialogContent>
//                         <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
//                     </DialogContent>
//                 </Dialog>
//             )}

//             {/* Old Group Popup Dialog */}
//             <Dialog open={openGroupPopup} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth>
//                 <DialogContent>
//                     <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
//                 </DialogContent>
//             </Dialog>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%", fontSize: { xs: "0.85rem", sm: "0.95rem" }, fontWeight: 600, boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)" }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default InsertProduct;













import { colors as themeColors } from '../utils/theme';
import { colors, primaryAlpha } from '../utils/theme';
import React, { useState, useRef, useMemo, useEffect } from "react";
import {
    Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress,
    Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Tooltip, Dialog, DialogContent, useMediaQuery, useTheme
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ProGroupMaster from './ProGroupMaster';
import { useAuth } from '../context/AuthContext';
import { getCurrentFYear } from '../utils/financialYear';

// ✅ OPTIMIZATION: Simple ID generator with minimal overhead
const generateUniqueId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

const normalize = (s) => String(s || "").trim().toLowerCase();

// ── Design tokens (Facebook blue · grey 200 · arctic white) ─────────────────
const C = {
    blue: colors.primary.main,
    blueDark: themeColors.primary.dark,
    tint: '#E7F0FE',
    ink: themeColors.neutral.ink,
    sub: themeColors.neutral.sub,
    mute: themeColors.neutral.muted,
    line: '#E4E6EB',
    hover: '#F0F2F5',
    page: '#F5F7FA',
    white: themeColors.neutral.surface,
    green: themeColors.success.dark,
    greenTint: '#E8F5E9',
    amber: themeColors.warning.main,
    amberTint: '#FFF8E1',
    red: '#E53935',
    redTint: '#FDECEA',
};

// Records panel: clean white card (search + scrolling list live inside)
const GlassParentCard = ({ children }) => (
    <Paper
        elevation={0}
        sx={{
            borderRadius: 3,
            bgcolor: C.white,
            border: `1px solid ${C.line}`,
            boxShadow: "0 1px 2px rgba(15,23,42,0.04), 0 8px 24px rgba(15,23,42,0.05)",
            position: "relative",
            overflow: "hidden",
            maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" },
            display: "flex",
            flexDirection: "column",
        }}
    >
        {children}
    </Paper>
);

// File drop zone
const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const droppedFiles = e.dataTransfer.files;
        if (droppedFiles.length > 0) {
            fileInputRef.current.files = droppedFiles;
            const event = new Event('change', { bubbles: true });
            Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
            handleFileChange(event);
        }
    };

    return (
        <Box
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            sx={{
                position: "relative",
                borderRadius: 3,
                border: `2px dashed ${isDragOver ? C.blue : '#CFD6E0'}`,
                p: { xs: 2.5, sm: 3 },
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2.5,
                bgcolor: isDragOver ? C.tint : '#FAFBFC',
                transition: "all 0.25s ease",
                "&:hover": { borderColor: C.blue, bgcolor: '#F5F9FF' },
            }}
        >
            <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0, textAlign: { xs: "center", sm: "left" }, flexDirection: { xs: "column", sm: "row" } }}>
                <Box sx={{
                    width: 56, height: 56, borderRadius: 2.5, flexShrink: 0,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    bgcolor: file ? C.greenTint : C.tint,
                    color: file ? C.green : C.blue,
                    transition: "all 0.25s ease",
                    transform: isDragOver ? "scale(1.08)" : "none",
                }}>
                    {file ? <CheckCircleIcon sx={{ fontSize: 30 }} /> : <CloudUploadIcon sx={{ fontSize: 30 }} />}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 700, color: C.ink, fontSize: { xs: "0.95rem", sm: "1.05rem" }, wordBreak: "break-word" }}>
                        {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
                    </Typography>
                    <Typography sx={{ color: C.sub, fontSize: { xs: "0.78rem", sm: "0.85rem" }, mt: 0.25 }}>
                        Excel (.xlsx, .xls) or CSV files only
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="contained"
                onClick={(e) => {
                    e.stopPropagation();
                    const hasError = data.some(r => r._missingFields?.length > 0);
                    if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
                        return;
                    }
                    fileInputRef.current.click();
                }}
                sx={{
                    height: 42,
                    flexShrink: 0,
                    px: 3,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "0.92rem",
                    whiteSpace: "nowrap",
                    background: `linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%)`,
                    boxShadow: `0 4px 14px ${primaryAlpha(0.3)}`,
                    transition: "transform .2s ease, box-shadow .2s ease",
                    "&:hover": { boxShadow: `0 8px 20px ${primaryAlpha(0.4)}`, transform: "translateY(-2px)" },
                    "&:active": { transform: "translateY(0) scale(.99)" },
                }}
            >
                Browse
            </Button>
        </Box>
    );
};

const InsertProduct = ({ connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = connectionString;
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [progressValue, setProgressValue] = useState(0);
    const [bufferValue, setBufferValue] = useState(0);
    const [showBuffer, setShowBuffer] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [searchText, setSearchText] = useState("");
    const [expandedCards, setExpandedCards] = useState({});
    const [filterMode, setFilterMode] = useState('all');
    const [groupNames, setGroupNames] = useState([]);
    const [openGroupPopup, setOpenGroupPopup] = useState(false);
    const [selectedItemGroup, setSelectedItemGroup] = useState('');
    const [selectedItemId, setSelectedItemId] = useState('');
    const [openSearchPopup, setOpenSearchPopup] = useState(false);
    const [searchGroupQuery, setSearchGroupQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [showCreateGroupForm, setShowCreateGroupForm] = useState(false);
    const [selectedGroupFromSearch, setSelectedGroupFromSearch] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [newlyCreatedGroupName, setNewlyCreatedGroupName] = useState(null);
    const [groupCreatedFromPopup, setGroupCreatedFromPopup] = useState(false);
    const [rowStatus, setRowStatus] = useState({});
    const [fadeOutIds, setFadeOutIds] = useState(new Set());

    // ✅ OPTIMIZATION: Increased parallel requests
    const PARALLEL_REQUESTS = 10;
    const abortControllerRef = useRef(null);

    const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));

    console.log("InsertProduct props:", { user, selectedCompany, connectionString });

    const companyId = selectedCompany?.CompId || null;
    const fYear = getCurrentFYear();
    const userId = user?.UserId || null;
    const branchId = selectedCompany?.[0]?.BranchId;
    console.log("username:", user.UserName)

    const fetchGroupNames = async () => {
        try {
            const response = await axios.get(`${path}/api/product-get-data/api/item-group`);
            const groups = response.data;
            setGroupNames(groups);
            return groups;
        } catch (error) {
            console.error('Error fetching group names:', error);
            setSnackbar({ open: true, message: "Error fetching group names", severity: "error" });
        }
    };

    // ✅ OPTIMIZATION: Clear cache on component mount
    useEffect(() => {
        const clearCacheOnLoad = async () => {
            try {
                console.log("Clearing cache on page load...");
                await axios.post(`${path}/api/product-clear-cache`, {}, {
                    timeout: 5000
                });
                console.log("✅ Cache cleared on load");
            } catch (error) {
                console.warn("⚠️ Cache clear on load failed (non-critical):", error.message);
            }
        };

        clearCacheOnLoad();
        fetchGroupNames();
    }, [path]);

    useEffect(() => {
        const hasRedError = data.some(r => r._missingFields?.length > 0);
        const handleBeforeUnload = (e) => {
            if (hasRedError && data.length > 0) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [data]);

    const updateProgress = (value) => {
        const clipped = Math.max(0, Math.min(100, value));
        setProgressValue(clipped);
        setBufferValue(Math.min(100, clipped + 10));
    };

    const hasFieldError = (record, fieldKey) => {
        if (!record._missingFields) return false;
        const fieldMap = {
            PrimaryGroup: 'PrimaryGroup',
            ItemGroup: 'itemGroup',
            ItemCode: 'itemCode',
            Description: 'description',
            Specification: 'Specification',
            ValueRate: 'ValRate',
            Unit: 'unit',
            HSN: 'HSN',
            GST: 'GST',
            applyStock: 'applyStock',
            ApplyBatch: 'applyBatch',
            Pkg: 'pkg',
            ConvQty: 'Conversion Qty',
            OpStock: 'Opening Stock',
            SaleRate: 'Sale Rate',
            SaleDiscount: 'Sale Discount (%)',
            PurchaseRate: 'Purchase Rate',
            PurchaseDiscount: 'Purchase Discount (%)',
            MinLevel: 'Min Level',
            MaxLevel: 'Max Level',
            MinOrderQty: 'MOQ',
            SelfLife: 'Self Life'
        };
        const errorLabel = fieldMap[fieldKey];
        return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
    };

    const handleFileChange = async (e) => {
        // ✅ OPTIMIZATION: Clear cache before processing new file
        try {
            await axios.post(`${path}/api/product-clear-cache`, {}, {
                timeout: 5000
            });
            console.log("Cache cleared before file processing");
        } catch (error) {
            console.warn("Cache clear before file processing failed (continuing anyway)");
        }

        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const validExtensions = [".xlsx", ".xls", ".csv"];
            const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
                setFile(null);
                setData([]);
                setFilteredData([]);
                fileInputRef.current.value = "";
                return;
            }

            setFile(selectedFile);
            fileInputRef.current.value = null;

            // Reset states
            setData([]);
            setFilteredData([]);
            setRowStatus({});
            setFadeOutIds(new Set());
            setShowBuffer(true);
            setFilterMode('all');
            updateProgress(3);

            // Clone file to force fresh read
            const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
            processFile(clonedFile);
        }
    };

    const processFile = (file) => {
        const reader = new FileReader();

        reader.onprogress = (e) => {
            if (e.lengthComputable) {
                const percentRead = Math.round((e.loaded / e.total) * 100);
                const mapped = Math.round(percentRead * 0.5);
                updateProgress(mapped);
            }
        };

        reader.onload = (e) => {
            try {
                const binaryData = e.target.result;
                const workbook = XLSX.read(binaryData, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const headers = jsonData[0] || [];

                // ✅ Build dynamic header index map
                const headerIndexMap = {};
                headers.forEach((h, i) => {
                    if (h) headerIndexMap[String(h).trim()] = i;
                });

                // ✅ Only required columns must exist in file
                const requiredColumns = ["PrimaryGroup", "itemGroup", "itemCode", "description", "unit"];
                const missingColumns = requiredColumns.filter(col => headerIndexMap[col] === undefined);
                if (missingColumns.length > 0) {
                    setSnackbar({
                        open: true,
                        message: `Missing required columns: ${missingColumns.join(", ")}`,
                        severity: "error"
                    });
                    setData([]);
                    setFilteredData([]);
                    updateProgress(0);
                    setShowBuffer(false);
                    return;
                }

                const parseNumber = (val) => {
                    if (val === null || val === undefined || val === "") return "";
                    const num = parseFloat(String(val).trim());
                    return isNaN(num) ? "INVALID" : num;
                };

                const requiredFields = [
                    { key: 'PrimaryGroup', label: 'PrimaryGroup' },
                    { key: 'ItemGroup', label: 'itemGroup' },
                    { key: 'ItemCode', label: 'itemCode' },
                    { key: 'Description', label: 'description' },
                    { key: 'Unit', label: 'unit' }
                ];

                // const yesValues = ['Yes', 'yes', 'Y', 'y'];
                // const noValues = ['No', 'no', 'N', 'n'];

                const yesValues = ['Yes', 'yes', 'Y', 'y', 'True', 'true', 'TRUE', '1', 1, true];
                const noValues = ['No', 'no', 'N', 'n', 'False', 'false', 'FALSE', '0', 0, false];

                // ✅ OPTIMIZATION: Process rows in chunks to avoid memory issues
                const CHUNK_SIZE = 500;
                const allParsedData = [];

                for (let chunkStart = 1; chunkStart < jsonData.length; chunkStart += CHUNK_SIZE) {
                    const chunkEnd = Math.min(chunkStart + CHUNK_SIZE, jsonData.length);
                    const chunk = jsonData.slice(chunkStart, chunkEnd);

                    const parsedChunk = chunk.map((row, idx) => {
                        // ✅ Helper to get value by column name dynamically
                        const getVal = (colName) => {
                            const i = headerIndexMap[colName];
                            return i !== undefined ? (row[i] ?? "") : "";
                        };

                        const raw = {
                            PrimaryGroup: String(getVal("PrimaryGroup") || "").trim(),
                            ItemGroup: String(getVal("itemGroup") || "").trim(),
                            applyStock: String(getVal("applyStock") || "").trim(),
                            ApplyBatch: String(getVal("applyBatch") || "").trim(),
                            ItemCode: String(getVal("itemCode") || "").trim(),
                            Description: String(getVal("description") || "").trim(),
                            Specification: String(getVal("Specification") || "").trim(),
                            ValueRate: parseNumber(getVal("ValRate")),
                            Unit: String(getVal("unit") || "").trim(),
                            Pkg: parseNumber(getVal("pkg")),
                            HSN: String(getVal("HSN") || "").trim(),
                            GST: String(getVal("GST") || "").trim(),
                            ConvUnit: String(getVal("convUnit") || "").trim(),
                            ConvQty: parseNumber(getVal("convQty")),
                            OpStock: parseNumber(getVal("opStock")),
                            SaleRate: parseNumber(getVal("saleRate")),
                            SaleDiscount: parseNumber(getVal("saleDiscount")),
                            PurchaseRate: parseNumber(getVal("purchaseRate")),
                            PurchaseDiscount: parseNumber(getVal("purchaseDiscount")),
                            MinLevel: parseNumber(getVal("minLevel")),
                            MaxLevel: parseNumber(getVal("maxLevel")),
                            MinOrderQty: parseNumber(getVal("minOrderQty")),
                            SelfLife: parseNumber(getVal("selfLife"))
                        };

                        const errors = [];

                        requiredFields.forEach(f => {
                            if (!raw[f.key]) {
                                errors.push(f.label);
                            }
                        });

                        if (raw.applyStock && !yesValues.includes(raw.applyStock) && !noValues.includes(raw.applyStock)) {
                            errors.push("applyStock (must be Yes/Y or No/N)");
                        }
                        if (raw.ApplyBatch && !yesValues.includes(raw.ApplyBatch) && !noValues.includes(raw.ApplyBatch)) {
                            errors.push("applyBatch (must be Yes/Y or No/N)");
                        }

                        if (raw.Pkg === "INVALID") {
                            errors.push("Pkg. (must be a number like 5 or 3.7)");
                        }

                        if (raw.GST && !/^\d+$/.test(raw.GST)) {
                            errors.push("GST (must be integer like 10, 18, 28)");
                        }

                        if (raw.HSN) {
                            const hsnDigits = raw.HSN.replace(/\D/g, '');
                            const digitCount = hsnDigits.length;
                            if (digitCount !== 4 && digitCount !== 6 && digitCount !== 8) {
                                errors.push("HSN (must be 4, 6, or 8 digits)");
                            }
                        }

                        const numericFields = [
                            { key: 'Pkg', label: 'Pkg.' },
                            { key: 'ConvQty', label: 'Conversion Qty' },
                            { key: 'OpStock', label: 'Opening Stock' },
                            { key: 'SaleRate', label: 'Sale Rate' },
                            { key: 'SaleDiscount', label: 'Sale Discount (%)' },
                            { key: 'PurchaseRate', label: 'Purchase Rate' },
                            { key: 'PurchaseDiscount', label: 'Purchase Discount (%)' },
                            { key: 'MinLevel', label: 'Min Level' },
                            { key: 'MaxLevel', label: 'Max Level' },
                            { key: 'MinOrderQty', label: 'MOQ' },
                            { key: 'SelfLife', label: 'Self Life' }
                        ];

                        numericFields.forEach(f => {
                            const value = raw[f.key];
                            if (value === "" || value === null) return;
                            if (value === "INVALID" || isNaN(value)) {
                                errors.push(`${f.label} (must be a number like 5 or 3.4)`);
                            }
                        });

                        // ✅ NEW LOGIC: Check both PrimaryGroup and ItemGroup existence
                        const matchedPrimaryGroup = groupNames.find(g =>
                            normalize(g.GroupName) === normalize(raw.PrimaryGroup) &&
                            g.IsPrimary === 1
                        );

                        const matchedItemGroup = groupNames.find(g =>
                            normalize(g.GroupName) === normalize(raw.ItemGroup) &&
                            g.IsPrimary === 0
                        );

                        // ✅ If PrimaryGroup doesn't exist, show error
                        if (!matchedPrimaryGroup) {
                            errors.push("PrimaryGroup (not found in database)");
                        }

                        // ✅ If PrimaryGroup exists but ItemGroup doesn't, mark for auto-creation
                        // ✅ FIXED: Explicitly set as boolean true/false
                        let needsItemGroupCreation = false;
                        if (matchedPrimaryGroup && !matchedItemGroup) {
                            needsItemGroupCreation = true;
                        }

                        // ✅ MODIFIED: Only show + icon if BOTH PrimaryGroup and ItemGroup don't exist
                        const showAddIcon = !matchedPrimaryGroup && !matchedItemGroup;

                        const record = {
                            id: generateUniqueId(),
                            PrimaryGroup: raw.PrimaryGroup,
                            ItemGroup: raw.ItemGroup,
                            applyStock: raw.applyStock === "" ? 0 : yesValues.includes(String(raw.applyStock).trim()) ? 1 : 0,
                            ApplyBatch: raw.ApplyBatch === "" ? 0 : yesValues.includes(String(raw.ApplyBatch).trim()) ? 1 : 0,
                            ItemCode: raw.ItemCode,
                            Description: raw.Description,
                            Specification: raw.Specification,
                            ValueRate: raw.ValueRate === "" || raw.ValueRate === "INVALID" ? 0 : raw.ValueRate,
                            Unit: raw.Unit,
                            Pkg: raw.Pkg === "" || raw.Pkg === "INVALID" ? 0 : raw.Pkg,
                            HSN: raw.HSN ? raw.HSN.replace(/\D/g, '') : "",
                            GST: raw.GST ? parseInt(raw.GST, 10) : 0,
                            ConvQty: raw.ConvQty === "" || raw.ConvQty === "INVALID" ? 0 : raw.ConvQty,
                            OpStock: raw.OpStock === "" || raw.OpStock === "INVALID" ? "" : raw.OpStock,
                            SaleRate: raw.SaleRate === "" || raw.SaleRate === "INVALID" ? 0 : raw.SaleRate,
                            SaleDiscount: raw.SaleDiscount === "" || raw.SaleDiscount === "INVALID" ? 0 : raw.SaleDiscount,
                            PurchaseRate: raw.PurchaseRate === "" || raw.PurchaseRate === "INVALID" ? 0 : raw.PurchaseRate,
                            PurchaseDiscount: raw.PurchaseDiscount === "" || raw.PurchaseDiscount === "INVALID" ? 0 : raw.PurchaseDiscount,
                            MinLevel: raw.MinLevel === "" || raw.MinLevel === "INVALID" ? 0 : raw.MinLevel,
                            MaxLevel: raw.MaxLevel === "" || raw.MaxLevel === "INVALID" ? 0 : raw.MaxLevel,
                            MinOrderQty: raw.MinOrderQty === "" || raw.MinOrderQty === "INVALID" ? 0 : raw.MinOrderQty,
                            SelfLife: raw.SelfLife === "" || raw.SelfLife === "INVALID" ? 0 : raw.SelfLife,
                            ConvUnit: raw.ConvUnit,
                            companyId,
                            fYear,
                            userId,
                            _missingFields: errors,
                            isGroupValid: !!matchedItemGroup,
                            showAddIcon: showAddIcon,
                            isGroupMissing: !matchedItemGroup,
                            isGroupNotFound: !matchedItemGroup,
                            // ✅ FIXED: Explicitly boolean true/false
                            needsItemGroupCreation: needsItemGroupCreation === true ? true : false,
                            // ✅ FIXED: Explicitly parse to integer or null
                            primaryGroupId: matchedPrimaryGroup?.ProdGRPID ? parseInt(matchedPrimaryGroup.ProdGRPID) : null,
                            primaryGroupName: matchedPrimaryGroup?.GroupName || raw.PrimaryGroup
                        };

                        return record;
                    }).filter(row => row.ItemCode || row.Description || row.Unit);

                    allParsedData.push(...parsedChunk);
                }

                setData(allParsedData);
                setFilteredData(allParsedData);
                setRowStatus({});
                setFadeOutIds(new Set());

                updateProgress(50);
                setSnackbar({ open: true, message: `Successfully parsed ${allParsedData.length} records`, severity: "success" });

                updateProgress(100);
                setTimeout(() => {
                    setShowBuffer(false);
                    updateProgress(0);
                }, 800);
            } catch (err) {
                console.error(err);
                setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
                setData([]);
                setFilteredData([]);
                updateProgress(0);
                setShowBuffer(false);
            }
        };

        reader.onerror = () => {
            setSnackbar({ open: true, message: "Error reading file", severity: "error" });
            setData([]);
            setFilteredData([]);
            updateProgress(0);
            setShowBuffer(false);
        };

        reader.readAsBinaryString(file);
    };

    const handleAddGroupClick = (itemGroup, rowId) => {
        setSelectedItemGroup(itemGroup);
        setSelectedRowId(rowId);
        setOpenSearchPopup(true);
        setSearchGroupQuery('');
        setSearchResults([]);
        setShowCreateGroupForm(false);
    };

    const handleSelectGroupFromSearch = async (selectedGroup) => {
        try {
            const groupsResponse = await axios.get(`${path}/api/product-get-data/api/item-group?companyId=${companyId}`);
            const allGroups = groupsResponse.data;

            let primaryGroupName = '';
            if (selectedGroup.UnderGRP) {
                const primaryGroup = allGroups.find(g =>
                    String(g.ProdGRPID) === String(selectedGroup.UnderGRP) &&
                    g.IsPrimary === 1
                );
                if (primaryGroup) {
                    primaryGroupName = primaryGroup.GroupName;
                }
            }

            const updateRowWithGroup = (rows) => {
                return rows.map(row => {
                    if (row.id === selectedRowId) {
                        return {
                            ...row,
                            ItemGroup: selectedGroup.GroupName,
                            PrimaryGroup: primaryGroupName,
                            isGroupValid: true,
                            showAddIcon: false,
                            isGroupMissing: false,
                            isGroupNotFound: false,
                            _missingFields: (row._missingFields || []).filter(
                                err => !err.toLowerCase().includes("group")
                            )
                        };
                    }
                    return row;
                });
            };

            setData(prevData => updateRowWithGroup(prevData));
            setFilteredData(prevFilteredData => updateRowWithGroup(prevFilteredData));

        } catch (error) {
            console.error('Error selecting group:', error);
            setSnackbar({ open: true, message: "Error selecting group", severity: "error" });
        }

        setOpenSearchPopup(false);
        setSearchGroupQuery('');
        setSearchResults([]);
        setShowCreateGroupForm(false);
        setSelectedRowId(null);
    };

    const handleSearchGroups = async (searchText) => {
        setSearchGroupQuery(searchText);

        if (!searchText.trim()) {
            setSearchResults([]);
            return;
        }

        try {
            setSearchLoading(true);
            const params = {
                GroupCode: searchText,
                companyId: companyId,
                mode: 'search'
            };

            const dataRes = await axios.get(`${path}/api/group/search`, { params });
            setSearchResults(dataRes.data || []);
        } catch (error) {
            console.error('Error searching groups:', error);
            setSnackbar({ open: true, message: "Error searching groups", severity: "error" });
            setSearchResults([]);
        } finally {
            setSearchLoading(false);
        }
    };

    const handleOpenCreateGroupForm = () => {
        setShowCreateGroupForm(true);
        setOpenSearchPopup(true);
    };

    const handleCloseSearchPopup = async (meta) => {
        const createdGroupName = meta?.created ? meta.groupName : null;
        if (meta?.created) setGroupCreatedFromPopup(true);

        try {
            if (selectedGroupFromSearch && selectedRowId) {
                const { data: allGroups } = await axios.get(
                    `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
                );

                let primaryGroupName = '';

                if (selectedGroupFromSearch.UnderGRP) {
                    const primary = allGroups.find(
                        g =>
                            String(g.ProdGRPID) === String(selectedGroupFromSearch.UnderGRP) &&
                            g.IsPrimary === 1
                    );
                    if (primary) primaryGroupName = primary.GroupName;
                }

                const patchRow = rows =>
                    rows.map(row =>
                        row.id === selectedRowId
                            ? {
                                ...row,
                                ItemGroup: selectedGroupFromSearch.GroupName,
                                PrimaryGroup: primaryGroupName,
                                isGroupValid: true,
                                showAddIcon: false,
                                isGroupMissing: false,
                                isGroupNotFound: false,
                                _missingFields: (row._missingFields || []).filter(
                                    err => !err.toLowerCase().includes("group")
                                )
                            }
                            : row
                    );

                setData(prev => patchRow(prev));
                setFilteredData(prev => patchRow(prev));
            } else if ((createdGroupName || groupCreatedFromPopup) && selectedRowId) {
                const groupNameToMatch = createdGroupName || selectedItemGroup;

                const { data: allGroups } = await axios.get(
                    `${path}/api/product-get-data/api/item-group?companyId=${companyId}`
                );

                const newlyCreatedGroup = allGroups.find(
                    g =>
                        normalize(g.GroupName) === normalize(groupNameToMatch) &&
                        g.IsPrimary === 0 &&
                        g.UnderGRP
                );

                if (newlyCreatedGroup) {
                    let primaryGroupName = '';

                    const primary = allGroups.find(
                        g =>
                            String(g.ProdGRPID) === String(newlyCreatedGroup.UnderGRP) &&
                            g.IsPrimary === 1
                    );

                    if (primary) primaryGroupName = primary.GroupName;

                    const patchRow = rows =>
                        rows.map(row =>
                            row.id === selectedRowId
                                ? {
                                    ...row,
                                    ItemGroup: newlyCreatedGroup.GroupName,
                                    PrimaryGroup: primaryGroupName,
                                    isGroupValid: true,
                                    showAddIcon: false,
                                    isGroupMissing: false,
                                    isGroupNotFound: false,
                                    _missingFields: (row._missingFields || []).filter(
                                        err => !err.toLowerCase().includes("group")
                                    )
                                }
                                : row
                        );

                    setData(prev => patchRow(prev));
                    setFilteredData(prev => patchRow(prev));
                }
            }

            const updatedGroups = await fetchGroupNames();

            setData(prev =>
                prev.map(row => {
                    const matched = updatedGroups.find(
                        g =>
                            normalize(g.GroupName) === normalize(row.ItemGroup) &&
                            g.IsPrimary === 0
                    );

                    if (!matched) return row;

                    let primaryGroupName = row.PrimaryGroup;

                    if (matched.UnderGRP) {
                        const primary = updatedGroups.find(
                            g =>
                                String(g.ProdGRPID) === String(matched.UnderGRP) &&
                                g.IsPrimary === 1
                        );
                        if (primary) primaryGroupName = primary.GroupName;
                    }

                    return {
                        ...row,
                        ItemGroup: matched.GroupName,
                        PrimaryGroup: primaryGroupName,
                        isGroupValid: true,
                        showAddIcon: false,
                        isGroupMissing: false,
                        isGroupNotFound: false
                    };
                })
            );

            setFilteredData(prev =>
                prev.map(row => {
                    const matched = updatedGroups.find(
                        g =>
                            normalize(g.GroupName) === normalize(row.ItemGroup) &&
                            g.IsPrimary === 0
                    );

                    if (!matched) return row;

                    let primaryGroupName = row.PrimaryGroup;

                    if (matched.UnderGRP) {
                        const primary = updatedGroups.find(
                            g =>
                                String(g.ProdGRPID) === String(matched.UnderGRP) &&
                                g.IsPrimary === 1
                        );
                        if (primary) primaryGroupName = primary.GroupName;
                    }

                    return {
                        ...row,
                        ItemGroup: matched.GroupName,
                        PrimaryGroup: primaryGroupName,
                        isGroupValid: true,
                        showAddIcon: false,
                        isGroupMissing: false,
                        isGroupNotFound: false
                    };
                })
            );
        } catch (error) {
            console.error('handleCloseSearchPopup error:', error);
            setSnackbar({
                open: true,
                message: 'Error resolving Item Group',
                severity: 'error'
            });
        } finally {
            setOpenSearchPopup(false);
            setSearchGroupQuery('');
            setSearchResults([]);
            setShowCreateGroupForm(false);
            setSelectedGroupFromSearch(null);
            setSelectedRowId(null);
            setGroupCreatedFromPopup(false);
        }
    };

    useEffect(() => {
        if (!groupNames.length || !data.length) return;

        setData(prev => prev.map(row => {
            const m = groupNames.find(g =>
                normalize(g.GroupName) === normalize(row.ItemGroup) &&
                g.IsPrimary === 0
            );
            return { ...row, showAddIcon: !m };
        }));
    }, [groupNames]);

    const handleGroupPopupClose = async () => {
        setOpenGroupPopup(false);
        setSelectedItemGroup('');

        const updatedGroups = await fetchGroupNames();

        setData(prevData =>
            prevData.map(row => {
                const matchedGroup = updatedGroups.find(g =>
                    normalize(g.GroupName) === normalize(row.ItemGroup) &&
                    g.IsPrimary === 0
                );

                const shouldShowAddIcon = !matchedGroup;

                let primaryGroupName = row.PrimaryGroup;
                let itemGroupName = row.ItemGroup;

                if (matchedGroup) {
                    itemGroupName = matchedGroup.GroupName;

                    if (matchedGroup.UnderGRP) {
                        const primaryGroup = updatedGroups.find(g =>
                            String(g.ProdGRPID) === String(matchedGroup.UnderGRP) &&
                            g.IsPrimary === 1
                        );
                        if (primaryGroup) {
                            primaryGroupName = primaryGroup.GroupName;
                        }
                    }
                }

                return {
                    ...row,
                    PrimaryGroup: primaryGroupName,
                    ItemGroup: itemGroupName,
                    isGroupValid: !!matchedGroup && matchedGroup.IsPrimary === 0,
                    showAddIcon: shouldShowAddIcon
                };
            })
        );
    };

    // ✅ MODIFIED: Upload handler with backend auto-creation support
    const handleUploadSubmit = async () => {
        if (!data.length) {
            setSnackbar({ open: true, message: "No data to upload", severity: "error" });
            return;
        }

        const validRows = data.filter(r =>
            (!r._missingFields || r._missingFields.length === 0)
        );
        const errorRows = data.filter(r => r._missingFields?.length > 0);

        if (validRows.length === 0) {
            setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
            return;
        }

        if (!companyId || !userId) {
            setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
            return;
        }

        setUploading(true);
        setShowBuffer(true);
        updateProgress(0);

        let insertedCount = 0;
        let existsCount = 0;
        let notModifiedCount = 0;
        let failedCount = 0;
        let groupsCreatedCount = 0;
        const processedRowIds = [];

        try {
            // ✅ OPTIMIZATION: Process in parallel batches
            const batchSize = PARALLEL_REQUESTS;
            const totalBatches = Math.ceil(validRows.length / batchSize);

            for (let batchIdx = 0; batchIdx < totalBatches; batchIdx++) {
                const startIdx = batchIdx * batchSize;
                const endIdx = Math.min(startIdx + batchSize, validRows.length);
                const batchRows = validRows.slice(startIdx, endIdx);

                const promises = batchRows.map(async (row) => {
                    // ✅ FIXED: Explicitly ensure correct types before sending
                    const parsedPrimaryGroupId = row.primaryGroupId ? parseInt(row.primaryGroupId) : null;
                    const parsedNeedsItemGroupCreation = row.needsItemGroupCreation === true ? true : false;

                    const payload = {
                        GroupId: '',
                        itemGroup: row.ItemGroup,
                        primaryGroup: row.primaryGroupName || '',
                        // ✅ FIXED: Send as explicit integer
                        primaryGroupId: parsedPrimaryGroupId,
                        // ✅ FIXED: Send as explicit boolean
                        needsItemGroupCreation: parsedNeedsItemGroupCreation,
                        inStock: row.applyStock === 1 || row.applyStock === "1" ? 1 : 0,
                        applyBatch: row.ApplyBatch === 1 || row.ApplyBatch === "1" ? 1 : 0,
                        itemCode: row.ItemCode,
                        description: row.Description,
                        specification: row.Specification,
                        valueRate: row.ValueRate,
                        unit: row.Unit,
                        pkg: row.Pkg || 0,
                        HSN: row.HSN,
                        GST: row.GST,
                        optionalBalance: row.OpStock,
                        saleRate: row.SaleRate,
                        saleDiscount: row.SaleDiscount,
                        purchaseRate: row.PurchaseRate,
                        purchaseDiscount: row.PurchaseDiscount,
                        convUnit: row.ConvUnit || "",
                        convQty: row.ConvQty,
                        minLevel: row.MinLevel,
                        maxLevel: row.MaxLevel,
                        minOrderQty: row.MinOrderQty,
                        selfLife: row.SelfLife,
                        companyId,
                        addUserId: userId,
                        addUserDateTime: new Date().toISOString(),
                        branchId,
                        fYear,
                        groupOfCompanyId: companyId
                    };

                    // ✅ DEBUG: Log payload to verify types
                    console.log(`📤 Payload for ${payload.itemCode}:`, {
                        itemGroup: payload.itemGroup,
                        needsItemGroupCreation: payload.needsItemGroupCreation,
                        typeOfNeedsCreation: typeof payload.needsItemGroupCreation,
                        primaryGroupId: payload.primaryGroupId,
                        typeOfPrimaryGroupId: typeof payload.primaryGroupId
                    });

                    try {
                        const response = await axios.post(`${path}/api/product-bulk-Insert`, payload, {
                            validateStatus: (status) => [200, 201, 204, 304, 500].includes(status),
                            timeout: 30000
                        });

                        const status = response.status;
                        let message = "";
                        let severity = "error";

                        if (status === 201) {
                            message = response.data.groupCreated ? "Inserted (Group Created)" : "Inserted";
                            insertedCount++;
                            if (response.data.groupCreated) groupsCreatedCount++;
                            severity = "success";
                        } else if (status === 204) {
                            message = "Already Exists";
                            existsCount++;
                            severity = "warning";
                        } else if (status === 304) {
                            message = "Group not found";
                            notModifiedCount++;
                            severity = "warning";
                        } else if (status === 500) {
                            message = "Server Error";
                            failedCount++;
                            severity = "error";
                        }

                        setRowStatus(prev => ({
                            ...prev,
                            [row.id]: { status, message, severity }
                        }));

                        if (status === 201 || status === 204) {
                            processedRowIds.push(row.id);
                        }

                        console.log(`Row - Status: ${status} - ${message}`);
                    } catch (err) {
                        const status = err.response?.status || 500;
                        const message = status === 500 ? "Server Error" : "Failed";
                        failedCount++;
                        setRowStatus(prev => ({
                            ...prev,
                            [row.id]: { status, message, severity: "error" }
                        }));
                        console.error(`Row error:`, err.message);
                    }
                });

                // Wait for all promises in this batch
                await Promise.all(promises);

                // Update progress
                const progress = 50 + Math.round(((endIdx) / validRows.length) * 50);
                updateProgress(progress);
            }

            const parts = [];
            if (groupsCreatedCount) parts.push(`${groupsCreatedCount} Groups Auto-Created`);
            if (insertedCount) parts.push(`${insertedCount} Inserted`);
            if (existsCount) parts.push(`${existsCount} Already Exists`);
            if (notModifiedCount) parts.push(`${notModifiedCount} Not Modified`);
            if (failedCount) parts.push(`${failedCount} Failed`);
            if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

            setSnackbar({
                open: true,
                message: parts.join(" | "),
                severity: insertedCount > 0 ? "success" : "warning"
            });

            // ✅ OPTIMIZATION: Clear cache after successful upload
            setTimeout(async () => {
                try {
                    await axios.post(`${path}/api/product-clear-cache`, {}, {
                        timeout: 5000
                    });
                    console.log("✅ Cache cleared after upload");
                } catch (error) {
                    console.error("Cache clear after upload failed:", error);
                }

                const sortedFadeIds = processedRowIds
                    .map(id => ({ id, group: data.find(r => r.id === id)?.ItemGroup || "" }))
                    .sort((a, b) => (a.group || "").localeCompare(b.group || ""))
                    .map(item => item.id);

                sortedFadeIds.forEach((id, index) => {
                    setTimeout(() => {
                        setFadeOutIds(prev => new Set(prev).add(id));
                    }, index * 500);
                });

                setTimeout(() => {
                    setData(prev => prev.filter(r => !processedRowIds.includes(r.id)));
                    setRowStatus({});
                    setFadeOutIds(new Set());
                }, sortedFadeIds.length * 500 + 600);
            }, 3000);

        } catch (error) {
            console.error("Unexpected error:", error);
            setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
        } finally {
            setUploading(false);
            setShowBuffer(false);
            updateProgress(0);
        }
    };

    // Step back (do not push a new /productMaster entry) so ProductMaster's Cancel navigate(-1) lands where we started.
    const handleBackClick = () => { navigate(-1); };

    const sortedData = useMemo(() => {
        const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
        const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

        const groupNotFound = withoutError.filter(r => r.isGroupNotFound);
        const validRows = withoutError.filter(r => !r.isGroupNotFound);

        const sortByItemGroup = (a, b) => {
            const groupA = (a.ItemGroup || "").trim().toLowerCase();
            const groupB = (b.ItemGroup || "").trim().toLowerCase();
            return groupA.localeCompare(groupB);
        };

        const sortedWithError = [...withError].sort(sortByItemGroup);
        const sortedGroupNotFound = [...groupNotFound].sort(sortByItemGroup);
        const sortedValid = [...validRows].sort(sortByItemGroup);

        return [...sortedWithError, ...sortedGroupNotFound, ...sortedValid];
    }, [data]);

    const filteredDataFinal = useMemo(() => {
        let result = sortedData;

        if (filterMode === 'perfect') {
            result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
        } else if (filterMode === 'error') {
            result = result.filter(r => r._missingFields?.length > 0);
        }

        if (searchText.trim()) {
            const lowerSearch = searchText.toLowerCase();
            result = result.filter(row =>
                row.Description?.toLowerCase().includes(lowerSearch) ||
                row.ItemCode?.toLowerCase().includes(lowerSearch) ||
                row.Unit?.toLowerCase().includes(lowerSearch)
            );
        }

        return result;
    }, [sortedData, filterMode, searchText]);

    useMemo(() => {
        setFilteredData(filteredDataFinal);
    }, [filteredDataFinal]);

    const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
    const perfectCount = useMemo(() => data.length - errorCount, [data]);
    const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

    const fieldGroups = [
        {
            title: "Basic Info",
            icon: <BusinessIcon fontSize="small" />,
            fields: [
                { label: "Primary Group", key: "PrimaryGroup" },
                { label: "Item Group", key: "ItemGroup" },
                { label: "applyStock", key: "applyStock" },
                { label: "applyBatch", key: "ApplyBatch" },
                { label: "Item Code", key: "ItemCode" },
                { label: "Description", key: "Description" },
                { label: "Specification", key: "Specification" },
                { label: "Value Rate", key: "ValueRate" },
                { label: "Unit", key: "Unit" },
                { label: "Pkg.", key: "Pkg" },
                { label: "HSN", key: "HSN" },
                { label: "GST", key: "GST" },
            ]
        },
        {
            title: "Conversion & Stock",
            icon: <InventoryIcon fontSize="small" />,
            fields: [
                { label: "Conversion Unit", key: "ConvUnit" },
                { label: "Conversion Qty", key: "ConvQty" },
                { label: "Opening Stock", key: "OpStock" },
                { label: "Min Level", key: "MinLevel" },
                { label: "Max Level", key: "MaxLevel" },
                { label: "MOQ", key: "MinOrderQty" },
                { label: "Self Life", key: "SelfLife" },
            ]
        },
        {
            title: "Pricing",
            icon: <PriceCheckIcon fontSize="small" />,
            fields: [
                { label: "Sale Rate", key: "SaleRate" },
                { label: "Sale Discount (%)", key: "SaleDiscount" },
                { label: "Purchase Rate", key: "PurchaseRate" },
                { label: "Purchase Discount (%)", key: "PurchaseDiscount" },
            ]
        }
    ];

    return (
        <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
            <style>{[
                "@keyframes ipFadeUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: none; } }",
                "@keyframes ipFadeIn { from { opacity: 0; } to { opacity: 1; } }",
            ].join("\n")}</style>

            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 2.5, gap: 2, flexWrap: "wrap", animation: "ipFadeUp .5s cubic-bezier(.22,1,.36,1) backwards" }}>
                <Tooltip title="Back to Product Master" placement="bottom">
                    <IconButton
                        onClick={handleBackClick}
                        sx={{
                            width: 42,
                            height: 42,
                            bgcolor: C.white,
                            color: C.sub,
                            border: `1px solid ${C.line}`,
                            borderRadius: 2,
                            flexShrink: 0,
                            transition: "all .2s ease",
                            "&:hover": { bgcolor: C.hover, color: C.ink, transform: "translateX(-2px)" },
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: 22 }} />
                    </IconButton>
                </Tooltip>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ color: C.mute, fontSize: "0.74rem", fontWeight: 500 }}>
                        Products › Import
                    </Typography>
                    <Typography sx={{ color: C.ink, fontWeight: 700, letterSpacing: "-0.4px", lineHeight: 1.2, fontSize: { xs: "1.3rem", sm: "1.6rem" } }}>
                        Product Data Upload
                    </Typography>
                    <Typography sx={{ color: C.sub, fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.25 }}>
                        Manage and import your product information
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* File Upload Card */}
                <Paper
                    elevation={0}
                    sx={{
                        p: { xs: 2, sm: 2.5 },
                        borderRadius: 3,
                        bgcolor: C.white,
                        border: `1px solid ${C.line}`,
                        boxShadow: "0 1px 2px rgba(15,23,42,0.04), 0 8px 24px rgba(15,23,42,0.05)",
                        animation: "ipFadeUp .5s cubic-bezier(.22,1,.36,1) .06s backwards",
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {/* File Upload Zone */}
                        <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

                        {/* Upload Controls & Progress */}
                        {(file || data.length > 0) && (
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, animation: "ipFadeIn .35s ease backwards" }}>
                                <Button
                                    variant="contained"
                                    onClick={handleUploadSubmit}
                                    disabled={uploading || !data.length || validRowsCount === 0}
                                    sx={{
                                        height: 44,
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        px: 3,
                                        minWidth: { xs: "auto", sm: 170 },
                                        gap: 1,
                                        fontSize: "0.95rem",
                                        background: `linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%)`,
                                        boxShadow: `0 4px 14px ${primaryAlpha(0.3)}`,
                                        transition: "transform .2s ease, box-shadow .2s ease",
                                        "&:hover": { boxShadow: `0 8px 20px ${primaryAlpha(0.4)}`, transform: "translateY(-2px)" },
                                        "&:active": { transform: "translateY(0) scale(.99)" },
                                        "&.Mui-disabled": { background: C.hover, color: C.mute, boxShadow: "none" },
                                    }}
                                >
                                    {uploading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 20 }} />}
                                    {uploading ? "Uploading..." : "Upload Records"}
                                </Button>
                                {showBuffer && (
                                    <Box sx={{ flex: 1, maxWidth: { sm: 360 } }}>
                                        <LinearProgress
                                            variant="buffer"
                                            value={progressValue}
                                            valueBuffer={bufferValue}
                                            sx={{
                                                height: 6,
                                                borderRadius: 4,
                                                backgroundColor: alpha(C.blue, 0.1),
                                                "& .MuiLinearProgress-dashed": { display: "none" },
                                                "& .MuiLinearProgress-bar2Buffer": { backgroundColor: alpha(C.blue, 0.18) },
                                                "& .MuiLinearProgress-bar": {
                                                    borderRadius: 4,
                                                    background: `linear-gradient(90deg, ${C.blue}, #60a5fa)`,
                                                },
                                            }}
                                        />
                                        <Typography sx={{ mt: 0.5, textAlign: "right", fontSize: "0.75rem", fontWeight: 600, color: C.blueDark }}>
                                            {uploading ? `${Math.round(progressValue)}%` : `Ready`}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>
                </Paper>

                {/* Summary tiles (Valid / Errors double as filters) */}
                {data.length > 0 && (
                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 1.5, animation: "ipFadeUp .5s cubic-bezier(.22,1,.36,1) .12s backwards" }}>
                        {[
                            { key: 'all', label: 'Total records', value: data.length, color: C.blue, tint: C.tint, icon: <InsertDriveFileIcon />, onClick: null, active: false },
                            { key: 'perfect', label: 'Valid', value: perfectCount, color: C.green, tint: C.greenTint, icon: <CheckCircleIcon />, onClick: () => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect'), active: filterMode === 'perfect' },
                            { key: 'error', label: 'Errors', value: errorCount, color: C.red, tint: C.redTint, icon: <ErrorIcon />, onClick: () => setFilterMode(prev => prev === 'error' ? 'all' : 'error'), active: filterMode === 'error' },
                        ].map((tile) => (
                            <Box
                                key={tile.key}
                                onClick={tile.onClick || undefined}
                                role={tile.onClick ? "button" : undefined}
                                sx={{
                                    display: "flex", alignItems: "center", gap: 1.5, p: 1.75,
                                    borderRadius: 3, bgcolor: tile.active ? tile.tint : C.white,
                                    border: `1px solid ${tile.active ? tile.color : C.line}`,
                                    boxShadow: tile.active ? `0 0 0 3px ${alpha(tile.color, 0.14)}` : "0 1px 2px rgba(15,23,42,0.04)",
                                    cursor: tile.onClick ? "pointer" : "default",
                                    transition: "all .22s ease",
                                    ...(tile.onClick ? { "&:hover": { transform: "translateY(-2px)", boxShadow: `0 8px 20px ${alpha(tile.color, 0.16)}`, borderColor: tile.color } } : {}),
                                }}
                            >
                                <Box sx={{ width: 42, height: 42, borderRadius: 2, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: tile.active ? tile.color : tile.tint, color: tile.active ? themeColors.neutral.surface : tile.color, transition: "all .22s ease" }}>
                                    {tile.icon}
                                </Box>
                                <Box>
                                    <Typography sx={{ color: C.ink, fontWeight: 800, fontSize: "1.35rem", lineHeight: 1.1 }}>{tile.value}</Typography>
                                    <Typography sx={{ color: C.sub, fontSize: "0.78rem", fontWeight: 600 }}>
                                        {tile.label}{tile.onClick ? (tile.active ? " · filtering" : "") : ""}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}

                {/* Data Display Section */}
                {data.length > 0 && (
                    <GlassParentCard>
                        {/* Search Bar */}
                        <Box sx={{ p: { xs: 1.5, sm: 2 }, pb: 1.5, display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                            <TextField
                                size="small"
                                placeholder={isMobile ? "Search products..." : "Search by description, code, unit..."}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ fontSize: 20, color: C.mute }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    flex: 1,
                                    minWidth: 220,
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        bgcolor: "#FAFBFC",
                                        fontSize: "0.9rem",
                                        transition: "all .2s ease",
                                        "& fieldset": { borderColor: C.line },
                                        "&:hover fieldset": { borderColor: C.blue },
                                        "&.Mui-focused": { bgcolor: C.white, boxShadow: `0 0 0 4px ${primaryAlpha(0.12)}` },
                                        "&.Mui-focused fieldset": { borderColor: C.blue, borderWidth: 2 },
                                    },
                                }}
                            />
                            <Typography sx={{ color: C.sub, fontSize: "0.8rem", fontWeight: 600, whiteSpace: "nowrap" }}>
                                Showing {filteredData.length} of {data.length}
                            </Typography>
                        </Box>
                        <Divider sx={{ borderColor: C.line }} />

                        {/* Records Container */}
                        <Box
                            flex={1}
                            overflow="auto"
                            p={{ xs: 1.5, sm: 2 }}
                            sx={{
                                bgcolor: C.page,
                                maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" },
                                '&::-webkit-scrollbar': { width: '8px' },
                                '&::-webkit-scrollbar-track': { background: "transparent" },
                                '&::-webkit-scrollbar-thumb': { background: "#CBD2DC", borderRadius: '10px', '&:hover': { background: C.mute } },
                            }}
                        >
                            <Stack spacing={{ xs: 1.25, sm: 1.5 }}>
                                {filteredData.length === 0 ? (
                                    <Box sx={{ py: 5, textAlign: "center", borderRadius: 3, bgcolor: C.white, border: `1px dashed ${C.line}` }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                                            <Box sx={{ width: 56, height: 56, borderRadius: "50%", bgcolor: C.hover, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <SearchIcon sx={{ fontSize: 28, color: C.mute }} />
                                            </Box>
                                            <Typography sx={{ color: C.sub, fontSize: "1rem", fontWeight: 600 }}>
                                                {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ) : (
                                    filteredData.map((r, idx) => {
                                        const missing = r._missingFields || [];
                                        const isError = missing.length > 0;
                                        const expanded = expandedCards[r.id];
                                        const statusInfo = rowStatus[r.id];
                                        const isFading = fadeOutIds.has(r.id);

                                        let cardBg = C.white;
                                        let accent = C.blue;
                                        let borderColor = C.line;
                                        let statusChip = null;

                                        if (statusInfo) {
                                            if (statusInfo.status === 201) {
                                                cardBg = "#F6FBF7";
                                                accent = C.green;
                                                borderColor = alpha(C.green, 0.35);
                                                statusChip = { color: C.green, bg: C.greenTint, icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: statusInfo.message || "Inserted" };
                                            } else if ([204, 304].includes(statusInfo.status)) {
                                                cardBg = "#FFFDF5";
                                                accent = C.amber;
                                                borderColor = alpha(C.amber, 0.4);
                                                const label = statusInfo.status === 204 ? "Already Exists" : "Group not found";
                                                statusChip = { color: "#B45309", bg: C.amberTint, icon: <WarningIcon sx={{ fontSize: 14 }} />, label };
                                            } else {
                                                cardBg = "#FFF8F7";
                                                accent = C.red;
                                                borderColor = alpha(C.red, 0.35);
                                                statusChip = { color: C.red, bg: C.redTint, icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
                                            }
                                        } else if (isError) {
                                            cardBg = "#FFF8F7";
                                            accent = C.red;
                                            borderColor = alpha(C.red, 0.35);
                                        }

                                        return (
                                            <Card
                                                key={r.id}
                                                elevation={0}
                                                sx={{
                                                    borderRadius: 3,
                                                    bgcolor: cardBg,
                                                    border: `1px solid ${borderColor}`,
                                                    borderLeft: `4px solid ${accent}`,
                                                    position: "relative",
                                                    overflow: "visible",
                                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                                    opacity: isFading ? 0 : 1,
                                                    transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)",
                                                    height: isFading ? 0 : "auto",
                                                    marginBottom: isFading ? "-10px" : 0,
                                                    padding: 0,
                                                    animation: `ipFadeUp .45s cubic-bezier(.22,1,.36,1) ${Math.min(idx, 10) * 0.04}s backwards`,
                                                    "&:hover": {
                                                        boxShadow: isError ? "0 8px 24px rgba(229,57,53,0.12)" : "0 8px 24px rgba(15,23,42,0.08)",
                                                    }
                                                }}
                                            >
                                                <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: { xs: 1.5, sm: 2 } } }}>
                                                    {/* Main Header Row */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            gap: { xs: 1.5, sm: 2, md: 3 },
                                                            flexWrap: { xs: "wrap", md: "nowrap" }
                                                        }}
                                                    >
                                                        {/* Item Info */}
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: { xs: "1 1 100%", md: "0 0 300px" }, minWidth: 0 }}>
                                                            <Box
                                                                sx={{
                                                                    background: statusInfo?.status === 201 ? `linear-gradient(135deg, ${C.green}, #66bb6a)` : (isError ? `linear-gradient(135deg, ${C.red}, #ef5350)` : `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`),
                                                                    color: "white",
                                                                    width: 44,
                                                                    height: 44,
                                                                    borderRadius: 2,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontWeight: 700,
                                                                    flexShrink: 0,
                                                                    fontSize: "1.15rem",
                                                                    boxShadow: "0 4px 12px rgba(15,23,42,0.15)"
                                                                }}
                                                            >
                                                                {r.ItemGroup?.[0]?.toUpperCase() || "?"}
                                                            </Box>
                                                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                                                <Typography noWrap sx={{ color: C.ink, fontWeight: 700, fontSize: { xs: "0.98rem", sm: "1.05rem" }, letterSpacing: "-0.2px" }}>
                                                                    {r.ItemGroup || "Unnamed"}
                                                                </Typography>
                                                                <Typography noWrap sx={{ color: C.sub, fontSize: { xs: "0.75rem", sm: "0.84rem" }, mt: 0.15 }}>
                                                                    {r.ItemCode || "—"} • {r.Unit || "—"}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        {/* Quick Info - Responsive Grid */}
                                                        <Box
                                                            sx={{
                                                                display: 'grid',
                                                                gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, minmax(0, 1fr))" },
                                                                gap: 1,
                                                                flex: { xs: "1 1 100%", md: 1 },
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            {[
                                                                { label: "HSN", value: r.HSN || "—", key: "HSN", icon: "📍" },
                                                                { label: "GST", value: r.GST || "—", key: "GST", icon: "🏛️" },
                                                                { label: "Sale Rate", value: r.SaleRate || "—", key: "SaleRate", icon: "💰" },
                                                                { label: "Group", value: r.ItemGroup || "—", key: "ItemGroup", icon: "📦" }
                                                            ].map((item, i) => {
                                                                const hasErr = hasFieldError(r, item.key);
                                                                return (
                                                                    <Box
                                                                        key={i}
                                                                        sx={{
                                                                            bgcolor: hasErr ? C.redTint : "#F7F8FA",
                                                                            borderRadius: 1.75,
                                                                            px: 1.25,
                                                                            py: 0.9,
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            minWidth: 0,
                                                                            border: `1px solid ${hasErr ? alpha(C.red, 0.3) : "transparent"}`,
                                                                            transition: 'all 0.2s ease',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontWeight: 700,
                                                                                color: hasErr ? C.red : C.mute,
                                                                                lineHeight: 1.3,
                                                                                fontSize: "0.65rem",
                                                                                textTransform: "uppercase",
                                                                                letterSpacing: "0.6px"
                                                                            }}
                                                                        >
                                                                            {item.label}
                                                                        </Typography>
                                                                        <Typography
                                                                            noWrap
                                                                            sx={{
                                                                                mt: 0.25,
                                                                                fontWeight: 600,
                                                                                fontSize: { xs: "0.78rem", sm: "0.86rem" },
                                                                                color: C.ink,
                                                                            }}
                                                                        >
                                                                            {item.value}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>

                                                        {/* Status + Actions (Add Group + Expand) */}
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, ml: "auto" }}>
                                                            {statusChip && !isFading && (
                                                                <Box
                                                                    sx={{
                                                                        bgcolor: statusChip.bg,
                                                                        color: statusChip.color,
                                                                        px: 1.25,
                                                                        py: 0.4,
                                                                        borderRadius: 5,
                                                                        fontSize: "0.74rem",
                                                                        fontWeight: 700,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 0.5,
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    {statusChip.icon}
                                                                    {statusChip.label}
                                                                </Box>
                                                            )}
                                                            {!statusChip && isError && (
                                                                <Box sx={{ bgcolor: C.redTint, color: C.red, px: 1.25, py: 0.4, borderRadius: 5, fontSize: "0.74rem", fontWeight: 700, whiteSpace: "nowrap" }}>
                                                                    {missing.length} {missing.length === 1 ? "issue" : "issues"}
                                                                </Box>
                                                            )}
                                                            {r.showAddIcon && (
                                                                <Tooltip title="Add this Item Group">
                                                                    <IconButton
                                                                        onClick={() => handleAddGroupClick(r.ItemGroup, r.id)}
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: C.greenTint,
                                                                            color: C.green,
                                                                            transition: 'all 0.25s ease',
                                                                            "&:hover": { bgcolor: C.green, color: themeColors.neutral.surface, transform: 'scale(1.08)' },
                                                                        }}
                                                                    >
                                                                        <AddCircleIcon sx={{ fontSize: 22 }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => toggleExpand(r.id)}
                                                                sx={{
                                                                    bgcolor: expanded ? C.tint : C.hover,
                                                                    color: expanded ? C.blue : C.sub,
                                                                    transition: 'all 0.25s ease',
                                                                    "&:hover": { bgcolor: C.tint, color: C.blue },
                                                                }}
                                                            >
                                                                <ExpandMoreIcon sx={{ fontSize: 22, transform: expanded ? "rotate(180deg)" : "none", transition: "transform .25s ease" }} />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>

                                                    {/* Expanded Details */}
                                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                                        <Divider sx={{ my: 1.75, borderColor: C.line }} />

                                                        {isError && (
                                                            <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: C.redTint, border: `1px solid ${alpha(C.red, 0.25)}` }}>
                                                                <Typography sx={{ color: C.red, fontWeight: 700, fontSize: "0.78rem", mb: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}>
                                                                    <ErrorIcon sx={{ fontSize: 16 }} /> Fix these before uploading
                                                                </Typography>
                                                                {missing.map((m, mi) => (
                                                                    <Typography key={mi} sx={{ color: themeColors.error.darker, fontSize: "0.8rem" }}>• {m}</Typography>
                                                                ))}
                                                            </Box>
                                                        )}

                                                        <Box>
                                                            {fieldGroups.map((group, gIdx) => (
                                                                <Box key={gIdx} mb={2}>
                                                                    <Typography
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 0.75,
                                                                            mb: 1,
                                                                            color: C.blueDark,
                                                                            fontSize: "0.74rem",
                                                                            fontWeight: 700,
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.8px",
                                                                            "& svg": { fontSize: 16 },
                                                                        }}
                                                                    >
                                                                        {group.icon} {group.title}
                                                                    </Typography>
                                                                    <Grid container spacing={{ xs: 1, sm: 1.25 }}>
                                                                        {group.fields.map((f, fIdx) => {
                                                                            const fErr = hasFieldError(r, f.key);
                                                                            return (
                                                                                <Grid item xs={12} sm={6} md={4} key={fIdx}>
                                                                                    <Box sx={{ px: 1.25, py: 0.9, borderRadius: 1.75, bgcolor: fErr ? C.redTint : C.white, border: `1px solid ${fErr ? alpha(C.red, 0.35) : C.line}`, height: "100%" }}>
                                                                                        <Typography
                                                                                            sx={{
                                                                                                color: fErr ? C.red : C.mute,
                                                                                                fontWeight: 700,
                                                                                                fontSize: "0.65rem",
                                                                                                textTransform: "uppercase",
                                                                                                letterSpacing: "0.5px"
                                                                                            }}
                                                                                        >
                                                                                            {f.label}
                                                                                        </Typography>
                                                                                        <Typography sx={{ color: C.ink, fontWeight: 600, fontSize: "0.86rem", mt: 0.25, wordBreak: "break-word" }}>
                                                                                            {r[f.key] || "—"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Grid>
                                                                            );
                                                                        })}
                                                                    </Grid>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Collapse>
                                                </CardContent>
                                            </Card>
                                        );
                                    })
                                )}
                            </Stack>
                        </Box>
                    </GlassParentCard>
                )}
            </Box>
            {/* Group Search Dialog */}
            <Dialog open={openSearchPopup && !showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
                <DialogContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                        Search for Item Group: {selectedItemGroup}
                    </Typography>

                    <TextField fullWidth size="small" placeholder="Search by group name..." value={searchGroupQuery} onChange={(e) => handleSearchGroups(e.target.value)} sx={{ mb: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                    />

                    {searchLoading && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <CircularProgress size={40} />
                        </Box>
                    )}

                    {!searchLoading && searchResults.length > 0 && (
                        <Box sx={{ maxHeight: 300, overflow: 'auto', mb: 2 }}>
                            <Stack spacing={1}>
                                {searchResults.map((result) => (
                                    <Paper
                                        key={result.ProdGRPID}
                                        onClick={() => {
                                            if (result.IsPrimary === 1) {
                                                setSnackbar({ open: true, message: "Cannot select primary group. Select a non-primary group.", severity: "warning" });
                                                return;
                                            }
                                            handleSelectGroupFromSearch(result);
                                        }}
                                        sx={{ p: 2, bgcolor: result.IsPrimary === 1 ? themeColors.neutral.border : themeColors.neutral.surfaceMuted, border: result.IsPrimary === 1 ? `1px solid ${themeColors.neutral.lineStrong}` : `1px solid ${themeColors.neutral.line}`, borderRadius: 2, cursor: result.IsPrimary === 1 ? 'not-allowed' : 'pointer', opacity: result.IsPrimary === 1 ? 0.6 : 1, transition: 'all 0.3s ease', '&:hover': { bgcolor: result.IsPrimary === 1 ? themeColors.neutral.border : themeColors.neutral.border } }}
                                    >
                                        <Typography variant="body2" fontWeight={600}>
                                            {result.GroupName}
                                        </Typography>
                                        {result.IsPrimary === 1 && (
                                            <Typography variant="caption" sx={{ color: themeColors.neutral.muted }}>
                                                (Primary Group - Not Selectable)
                                            </Typography>
                                        )}
                                    </Paper>
                                ))}
                            </Stack>
                        </Box>
                    )}

                    {!searchLoading && searchGroupQuery && searchResults.length === 0 && (
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: 'center' }}>
                            No groups found. Create a new one?
                        </Typography>
                    )}

                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                        <Button variant="contained" color="success" onClick={handleOpenCreateGroupForm} startIcon={<AddCircleIcon />} >
                            Add New Group
                        </Button>
                        <Button variant="outlined" color="error" onClick={handleCloseSearchPopup} >
                            Cancel
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Create Group Dialog */}
            {showCreateGroupForm && (
                <Dialog open={openSearchPopup && showCreateGroupForm} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth >
                    <DialogContent>
                        <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
                    </DialogContent>
                </Dialog>
            )}

            {/* Old Group Popup Dialog */}
            <Dialog open={openGroupPopup} onClose={handleCloseSearchPopup} maxWidth="sm" fullWidth>
                <DialogContent>
                    <ProGroupMaster mode="add" onPopupCancel={handleCloseSearchPopup} user={user} selectedCompany={selectedCompany} connectionString={connectionString} initialGroupName={selectedItemGroup} />
                </DialogContent>
            </Dialog>

            {/* Snackbar */}
            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%", fontSize: { xs: "0.85rem", sm: "0.95rem" }, fontWeight: 600, boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)" }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default InsertProduct;